module.exports = {
    message: {
        home: {
            title: "屬於香港人的",
            subTitle: "“自選美食到會”"
        },
        client:{
            title:"過往客戶",
            nav:"過住合作客戶"
        },
        clinetContent:{
            partTitleOne:"服務及活動",
            partContentOne:"我們提供的美食及服務都是以客人要求為先，因此所有食物可直接送到你的住宅、辦公室或指定地點。我們的廚師團隊擁有豐富專業烹調經驗，嚴選食材炮製不同國家的美食，亦為顧客設計指定的多人套餐。你既可選購我們的恆常多人套餐，也可因應不同派對主題自選個人特定套餐，創造出屬於您心目中的專屬餐單。",
            activity:{
                activityName:"活動名稱:",
                activityService:"套餐美食:",
                activityNumber:"活動人數:",
                partTitleOne:"中環Clockenflap活動",
                partServiceOne:"新鮮沙律、熱湯、肉食、意粉、炒飯及精緻甜品",
                partTitleTwo:"相達生物科技全球總部開幕典禮 ",
                partServiceTwo:"法式酥皮、法式咸點撻、曲奇、中式點心及三文治",
                partTitleThree:"Volvo Ocean Race嘉年華",
                partServiceThree:"一口小食、小食拼盤盒、精美茶點及飲品",
                partTitleFour:"醫管局員工膳食",
                partServiceThour:"便當自選餐盒",
                partTitleFive:"GRAVITY 開幕慶典",
                partServiceFive:"一口小食、冷盤、烘焙食物及飲品吧",
                partTitleSix:"啟德郵輪碼頭活動",
                partServiceSix:"意粉、炒飯、冷盤、新鮮沙律及迷你蛋糕",
            }
        },
        waring: {
            h11: "爲確保服務質素",
            h12: "以下時段已經截單",
            h13: "18/9(六) 17:00-19:00",
            h14: "21/9(二) 18:00-23:59",
            h15: "不再接受新訂單",
            h16: "請選擇其他可預訂之時段",
            h17: "感謝您支持到會家",
        },
        meta: {
            index: {
                title: "香港到會服務推介 | 美食食物到會公司 - 到會家 Cateraway",
                description:
                    "搞派對聚會，「到會家」嘅1人1款皇牌平價自選到會，無論香港、九龍或新界都可送到。我們到會服務公司的食物製作以優質見稱，有70多款美食推介任君選擇！",
                keywords:
                    "到會,香港到會,到會服務,到會推介,到會服務推介,到會食物推介,美食到會,到會公司,到會小食,平價到會,到會觀塘,新年到會,聖誕到會,素食到會,到會套餐,特色到會,即日到會,到會外賣,好食到會,派對食物,小朋友生日會,婚禮到會,到會平,觀塘到會,旺角到會,元朗到會,中環到會,聖誕大餐,聖誕餐牌"
            },
            menu: {
                title: "到會餐單餐牌 | 平價到會 - 到會家 Cateraway",
                description:
                    "我們有不同類型的平價到會餐單，包括私人、商務派對、小朋友生日會、船P到會及午餐會等等類型的到會餐牌，皇牌餐單平均只需約$82/款就可以品嚐美味的到會，物美價廉真係超值啊！",
                keywords: "到會餐單,到會餐牌,平價到會,到會平",
            },
            enquiry: {
                title: "到會報價｜報價服務推介- 到會家 Cateraway",
                description:
                    "專營超過30款不同類型的商務活動餐飲報價，食物及服務包括廚師即制、Canapés、Finger Food、公司開幕、雞尾酒會、便當、大型活動、小食拼盤、週年晚會等，提供1對1的專人到會報價服務。",
                keywords:
                    "活動餐飲報價,報價服務,廚師即制,Canapés,公司開幕,雞尾酒會,大型活動"
            },
            corporateCatering: {
                title: "公司到會｜商戶合作- 到會家 Cateraway",
                description:
                    "到會家有自設食物工場，能烹調2-2000人不同形式的公司到會。我們與超過100+的Partyroom長期合作，亦有和不同的活動策劃公司合作多個中環的大型活動包括AIA嘉年華、Clockenflap，歡迎任何公司與我們聯絡合作長期到會服務。",
                keywords:
                    "Partyroom合作,活動策劃合作,公司合作,商戶合作,大型活動,長期到會,公司到會"
            },
            contact: {
                title: "聯絡我們｜全港餐飲到會- 到會家 Cateraway",
                description:
                    "到會家有自設食物工場，能烹調2-2000人不同形式的到會。我們與超過100+的Partyroom長期合作，亦有和不同的活動策劃公司合作多個中環的大型活動包括AIA嘉年華、Clockenflap，歡迎任何公司與我們聯絡合作長期到會服務。",
                keywords: "餐飲到會,聯絡我們,全港到會,中式餐單,西式餐單"
            },
            blog: {},
            partyFood: {
                title: "派對及小食到會推介 - 到會家 Cateraway",
                description:
                    "開Party，想訂派對及小食到會服務？到會家為你提供派對及小食到會美食預訂服務，你可以用至抵嘅優惠價錢自由任選各款小食和主食，是派對聚會，小朋友派對的必食之選。立即訂購，讓我們為你送上派對到會美食，讓您與好友一起分享快樂！",
                keywords: "派對到會,派對食物, party 到會"
            },
            christmasParty: {
                title: "聖誕到會 | 聖誕節派對更難忘精彩 - 到會家 Cateraway",
                description:
                    "聖誕節就嚟到啦，搞Party活動需要聖誕到會？到會家提供聖誕限定平價到會大餐，自由任選1人1款皇牌聖誕到會，聖誕必備火雞，聖誕Cupcake等。是聖誕聯歡會、公司Party、聖誕Party首選！送運至全港九新界，立即訂購！",
                keywords: "聖誕到會 聖誕派對"
            },
            birthdayParty: {
                title: "生日到會 | 小朋友生日會 - 到會家 Cateraway",
                description:
                    "到會家主營多年小朋友生日到會，餐單設計加入了多款無激素及營養均衡的食材專為小朋友而設，令到家長及小朋友都可以在生日會吃得開心和健康，一起來見證孩子的歡笑吧",
                keywords: "生日到會,小朋友生日會"
            },
            junkCatering: {
                title: "船P船河到會推介 - 到會家 Cateraway",
                description:
                    "開船Party，想訂船P船河到會服務？到會家為你提供60+多款船P船河到會美食預訂服務，你可以用至抵嘅優惠價錢自由任選各款小食和主食，是船P船河派對聚會的必食之選。立即訂購，讓我們為你送上船P船河派對到會美食，讓您與好友一起分享快樂！",
                keywords: "船P派對到會,船河派對到會,船P食物, 船P"
            },
            weddingCatering: {
                title: "婚禮到會推介 - 到會家 Cateraway",
                description:
                    "我們會為您進行一對一的到會訂制，可以根據您的婚禮到會推介更美好的食物，量身定做婚禮到會，從小食、甜品、飲品等，我們都一絲不苟為你見證人生最難忘的一刻和分享您們的喜悅！",
                keywords: "婚禮到會,婚禮到會推介"
            },
            halloween: {
                title: "萬聖節到會 | 萬聖節派對更好食好玩 - 到會家 Cateraway",
                description: "Helloween又嚟啦！需要萬聖節派對到會服務？到會家提供多款優惠價$82/盤的派對到會皇牌美食，小食、炸物、甜品，一應俱存。多年到會經驗，保證食材新鮮，熱辣辣送到府上。絕對是萬聖節到會，派對活動的必然之選！立即預訂！",
                keywords: ""
            },
            chineseCatering: {
                title: "中式到會 - 到會家 Cateraway",
                description:
                    "到會家有30年中餐經驗大廚主理廣東菜、素菜及傳統自家菜等中式到會，每逢佳節大厨都會親自編中式到會餐牌，如果親朋好友太多，就快訂購我們中菜送到府上作「加餸」慶佳節！",
                keywords: "中式到會"
            },
            westernCatering: {
                title: "西式到會 - 到會家 Cateraway",
                description:
                    "西式到會餐單由超過20年西餐經驗的大廚設計，我們還有精美西式小食、杯裝小食、高級商務小食、finger food及canapés到會等。讓我們設計您公司活動的西式到會餐單。",
                keywords: "西式到會"
            },
            thaiCatering: {
                title: "泰式到會 - 到會家 Cateraway",
                description:
                    "到會家的泰式到會餐單亦是由公司旗下的泰國餐廳廚師共同開發，所有的泰式到會是完全加入了泰國風味！泰式食物推介泰式炒金邊粉、泰式豬頸肉、傳統菠蘿炒飯及椰汁千層糕等等。",
                keywords: "泰式到會"
            },
            vegetarianCatering: {
                title: "素食到會 - 到會家 Cateraway",
                description:
                    "到會家除了皇牌餐單中的無肉之選之外，我們還可以烹調出中式素食及西式素食到會。我們誠邀多年西餐素食經驗大廚花費2年時間嚴選材料編制出自家素食到會，健康由食開始！",
                keywords: "素食到會"
            },
            bento: {
                title: "便當 | 便當盒 - 到會家 Cateraway",
                description:
                    "到會家會為您的公司每一位同事和上司設計一份完美的午餐便當，這將會是從前菜到甜點的一份體驗。如果您想為您的公司訂製便當，歡迎聯絡我們！這會是一個承載愛和心意的美食！",
                keywords: "便當"
            },
            centralAndWestern: {
                title: "中環到會 - 到會家 Cateraway",
                description:
                    "到會家專營超過100家中環公司到會，在中環到會曾服務包括Clockenflap音樂文化節、AIA嘉年華、中環太陽戲團、18+Central、公司雞尾酒會、公司商務會議等等。",
                keywords: "中環到會"
            },
            eastern: {
                title: "北角到會 - 到會家 Cateraway",
                description:
                    "到會家致力於鑽研北角到會新菜式服務各個商會及學校，商會服務如雞尾酒會、大型商業會議、船P、宴會、例會等都是我們服務的範疇內，另外學校的節日聯歡會、校運會、開放日等服務我們亦能為你服務。",
                keywords: "北角到會"
            },
            wanChai: {
                title: "銅鑼灣到會 - 到會家 Cateraway",
                description:
                    "到會家針對銅鑼灣到會從前菜、主食、小食及甜品的編排、食材的挑選、加工的程序都有大廚親自監管！公司講座、分享會、宴會、典禮、遊艇會等活動中提供到會餐飲服務。",
                keywords: "銅鑼灣到會"
            },
            kwunTong: {
                title: "觀塘到會 | 牛頭角/九龍灣到會 - 到會家 Cateraway",
                description:
                    "到會家針對不同商業活動製作$82/款的皇牌餐單，觀塘到會、牛頭角到會及九龍灣到會更是我們主要的客戶來源，推介公司例會、典禮、派對、講座和開張活動等公司活動訂購。",
                keywords: "觀塘到會,牛頭角到會,九龍灣到會"
            },
            shamShuiPo: {
                title: "長沙灣到會 - 到會家 Cateraway",
                description:
                    "到會家專門為商業、住宅、工業等用地提供$82／款物美價廉的長沙灣及荔枝角到會服務，餐單包括多國的特色菜式如泰國菠蘿炒飯、道地卡邦尼長通粉等更是長沙灣到會的熱門首選。",
                keywords: "長沙灣到會"
            },
            yauTsimMong: {
                title: "尖沙咀到會 | 旺角到會 - 到會家 Cateraway",
                description:
                    "到會家搜羅了不同國家、地區的菜式，從中挑選出適合尖沙咀到會及旺角到會的市場製作出獨特的菜式，$82就可體驗上至頭盤、主菜、小食及甜品下至運輸一條龍服務。",
                keywords: "尖沙咀到會,旺角到會"
            },
            kwaiTsing: {
                title: "葵涌到會 - 到會家 Cateraway",
                description:
                    "超過50款食物給選擇葵涌到會的您揀！由30年大廚主理中式、西式、泰式的到會。如果想訂購葵涌到會美食，除了電話預訂以外，亦可在到會家的網站預訂美食，提提您記得提前三天預訂！",
                keywords: "葵涌到會"
            },
            saiKung: {
                title: "西貢到會 | 將軍澳到會 - 到會家 Cateraway",
                description:
                    "專門提供西貢到會、將軍澳到會、康城及寶琳到會，滿足您船P、沙灘野餐、家庭聚會、船河等到會選擇。只需$82您就可以按照自己喜好挑選超過50款不同的食物組合，包您滿意！",
                keywords: "西貢到會,將軍澳到會"
            },
            shaTin: {
                title: "沙田到會 - 到會家 Cateraway",
                description:
                    "到會家是家庭客人沙田到會首選的原因是我們美食種類居多，從前菜到甜品有超過50款的美食。每一道菜式由20年西式餐廳大廚主理，為您家庭中的每一位成員考慮，立即打電話或網上預訂到會！",
                keywords: "沙田到會"
            },
            tsuenWan: {
                title: "荃灣到會 - 到會家 Cateraway",
                description:
                    "荃灣到會首選皇牌餐單，$82自選餐單從甜品、主食、小食都適合不同年齡層享用。每隔6個月就會推出一份新的潮流餐牌，顧客每一次來都有不同的體驗，將千奇百款的美食呈現在您眼前。",
                keywords: "荃灣到會"
            },
            tuenMun: {
                title: "屯門到會 - 到會家 Cateraway",
                description:
                    "網羅100款獨特的美食給屯門到會的朋友，全球配送食物。包括不同有名的各國餐館菜式、潮流特色美食、打卡甜品都應有盡有，還有專屬車隊為你送上熱辣辣的美食，快啲嚟揀啦！",
                keywords: "屯門到會"
            },
            yuenLong: {
                title: "元朗到會 - 到會家 Cateraway",
                description:
                    "到會家元朗到會專屬車隊為你服務，元朗的朋友們不用再擔心地區的問題喇！到會家收集中西泰日特色菜式，足不出戶就可以試足不同國家的特色小食、主食、甜品、素食等！",
                keywords: "元朗到會"
            }
        },
        camenu: {
            span1: "適合人數",
            span2: "價格",
            span3: "免運費",
            btn: "查看詳情",
        },
        buttons: {
            whatsApp: "WhatsApp訂購",
            linkButton: "網上訂購",
        },
        giftArea: {
            gift: "GiftArea",
            title: "送禮專區 | 生日禮物 | 聖誕禮物 | 情侶送禮",
            banner: {
                title: "送禮專區",
                subTitle: "生日禮物，聖誕禮物，男士送禮，女士送禮應有盡有！"
            },
            content: {
                title: "如何送最適合的禮物",
                p1: "到會家正在與香港原蜜合作，推出健康有益的原蜜產品，經香港標準及檢定中心(STC)和香港通用檢測認證 SGS，證實香港原蜜出產蜂蜜沒加工加熱、不摻糖、不含鈉、沒有抗生素，且不含農藥。由本地蜂場採集的原蜜，抗菌性強，每天食用一蜜匙，有助凍齡保健，含類黃酮(自然界最佳抗氧化劑)，具抗氧化活性，能抗衰老及寧血養神，適合做男士禮物，女士禮物，老人家禮物，生日禮物，聖誕禮物等等，蜂蜜是由蜜蜂經過充分釀造而成的一種甜物質，它的口感香甜，在給你帶去甜蜜的同時，還寓意著生活幸福美滿，如蜜一般甜美！",
                p2: "蜂蜜美容養顏的作用是毋庸質疑的，古有楊貴妃用蜂蜜護膚，不少明星都用蜂蜜保養，很多人都羨慕明星的逆齡生長，其實這源於她們正確的養生方法。蜂蜜中含有豐富的抗氧化劑，可以清除體內多餘的自由基，能夠延緩衰老。常喝蜂蜜水，能夠讓你的肌膚恢復水嫩如初。",
                p3: "現如今很多人都有不良的飲食習慣，暴飲暴食及不健康飲食已經成為了生活中很常見的事情。長期如此腸胃必會發生問題。蜂蜜中含有的活性酶可以維持胃酸的分泌，幫助腸胃分解和消化食物。在腸胃不舒服的時候喝一杯蜂蜜水，不僅可以緩解疼痛，還暖心又暖胃，無形中增加好感度！見到這麼多好處，還擔心送錯禮物？不知道送什麼禮物好？立即訂購健康有益的原蜜啦，我們提供全港送貨上門服務，只有搜尋生日禮物，聖誕禮物，男士送禮，女士送禮，禮物推薦等就可以尋找到我們啦！"
            }
        },
        caterwayReserve: {
            marqueeTitle: {
                zero: "優惠",
                first: "選擇“地面交收”免運費",
                second: '使用消費券，輸入優惠碼：CV88 即享88折優惠',
                third: "玩船P 開Party 出示相關證明即送精選甜品",
                four: "凡於網站訂購到會套餐，輸入優惠碼：CASH100，即享HK$100現金減免",
                five: "凡於網站訂購到會套餐，輸入優惠碼：SNACK2023，即享滋味小食：香蒜蜂蜜BBQ脆炸雞中翼（12隻）一盤"
            },
            title: "到會餐牌 | 平價到會 | 船P到會 | 西式到會 | 公司到會 | 泰式到會",
            banner: {
                title: "全新到會餐單體驗",
                subTitle: "自選到會餐牌，總有一款適合你"
            },
            context: {
                h2TitleOne: "平價到會 真係超值!",
                pContentOne: "我們不只到會平，物美價廉，而且在到會餐單設計方面一直都沿用著創新的思維和方法，每一款食物都經過多次試驗，為求您的活動可以變得更完美。我們在設計每一款的到會餐牌的時候，都是由我們的中、西式及泰式廚師代表共同開發，而每一位廚師平均都是有最少10年的廚房經驗，因此不少客人都對我們的餐牌感到十分滿意。",
                h2TitleSecond: "到會餐牌菜式多元 老少咸宜",
                pContentSecond: "不少客人都認為我們的菜式多元，不只有傳統美食，亦包含各國食物的特色，這絕對是我們的到會餐牌優勝之處。我們深明每個人都有各自的飲食喜好及要求，因此我們設計餐牌時，會加入不同食物類型、各國菜式，我們甚至設計出素食到會餐單，以滿足香港一眾食客的需求。",
                pContentSecondTwo: "我們在到會餐單設計方面一直都沿用著創新的思維和方法，每一款食物都經過多次試驗，由十多年經驗的大廚主理，並特意誠邀泰國名廚協助製作出香港一眾素食者的喜愛。",
                h2TitleThird: "平價到會 親民價錢 高級享受",
                pContentThird: "另外我們有不同的餐單類型，包括私人、商務、小朋友派對、船P及午餐會等等活動類型的到會餐牌，一些餐牌都是只需約$82/位就可以品嚐美食。而且每一款類型的餐單，我們都會有相對平價到會，令您可以根據您的活動選擇適合的到會平價美食。在每一份的到會餐單中，我們會根據客人的活動形式加設對應的服務，例如在午餐會中，我們可以提供侍應生服務客人、及對應的酒水等等餐單要求。"
            },
            aboutMenuTitle: "關於訂購及餐單 - 常見問題:",
            aboutMenu: {
                faq1: "1. 為何選擇我們的到會餐單？",
                content1: "選擇我們的餐單原因很簡單，就是菜式種類多、到會平價、收費相宜。我們提供的食物類型絕不單一，從沙律，冷盤、小食，到粉麵、飯類、甜品，選擇包羅萬有，而且我們的廚師定期會更新到會餐單，加入新創菜式，給予客人更多選擇，新鮮感十足。除此之外，我們提供價錢相對相宜的到會平價套餐，讓客人能在有限預算內品嚐得到富有質素的食品。",
                faq2: "2. 我們的到會餐牌一般可供多少人食用？ ",
                content2: "我們有不同份量的餐牌供選購，從10至20人的小型派對、到多達60至70人大型活動，我們都應付有餘。換句話說，不論活動人數多寡，我們都能提供相應的到會份量，滿足食客要求。",
                faq3: "3. 如何選擇高質素的平價到會？",
                content3: "市面上有不少公司都標榜提供平價到會選擇予客人，而曾有客人向我們反映到會平價、質素不一定好的經歷，有些公司提供到會平價餐，但食物選擇極少，食材用料亦不新鮮，甚至發生延遲運送等問題。要揀選高質素的平價到會，首先細閱其到會餐單，看看食物類型，是否非常單一、抑或有很多選擇？其次，了解當中的條款及細節，例如提供送貨服務與否。最後，查看客人的評價，參考實際評語能助你分辨出到店家食物及環境質素。",
                faq4: "4. 到會家的平價到會設送貨服務嗎？",
                content4: "我們除了提供美食外，亦設送貨服務，不論是到會平價套餐，或是標準價錢餐單，都由我們特別安排的速遞員，將暖呼呼的食物送遞至客人手上。特別地址如村屋，碼頭、或其他偏遠地區，請於下單時與我們的專員查詢送貨詳情，我們將盡力為您安排。",
            },
        },
        menuh1: "全新的到會體驗",
        menuh: "全新的到會點餐體驗",
        menuh2: "自選到會餐牌",
        wstag: "萬聖節到會服務",
        indextag: "到會家自選美食到會公司",
        menutag: "到會家自選到會餐單",
        kwuntag: "觀塘，牛頭角，九龍灣到會服務",
        wedtag: "到會家婚禮到會",
        top: "10月萬聖節限定驚喜，凡訂購14盤到會美食以上，即送甜品泡芙一客！",
        topbtn: "立即選購",
        salad: "沙律",
        staple: "主食",
        staple1: "主食1",
        staple2: "主食2",
        staple3: "主食3",
        special: "特式烘培",
        headplate: "頭盤",
        pinpan: "小食",
        snack: "小食及拼盤",
        snack1: "小食及拼盤1",
        snack2: "小食及拼盤2",
        snack3: "小食及拼盤3",
        sandwich: "三文治",
        vegetables: "蔬菜",
        dessert: "甜點",
        childrenarea: "小孩子专区",
        coldplate: "冷盤",
        burger: "迷你漢堡",
        addcommodity: "追加",
        adddrinks: "追加飲品",
        addservice: "追加服務",
        caterersmenu: {
            h1: "船P到會餐單",
            h2: "適合各種類型船P派對享用",
            h3: "【太極潮粵】新春盤菜",
            h4: "適合小型親友聚會",
            btn1: "立即選購"
        },
        footer: {
            telephone: "電話",
            whatsapp: "WhatsApp",
            address: "地址",
            address1: "香港觀塘開源道62號駱駝漆大廈1座12樓D室",
            emali: "電郵",
            leixing: "牌照編號",
            gongsi: "公司類型",
            gongsispan: "到會公司",
            terms: "使用條款",
            pri: "隱私政策"
        },
        nav: {
            btn1: "報價查詢",
            btn2: "到會訂購",
            btn3: "部落格",
            btn4: "送禮專區",
            index: "首頁",
            attend: "到會預定",
            activity: "活動報價",
            cooperation: "商戶合作",
            contact: "聯絡我們",
            party: "派對",
            christmas: "聖誕節",
            birthday: "生日",
            boat: "船P",
            wedding: "婚禮",
            halloween: "萬聖節",
            blog: "到會指南",
            dishes: "菜式",
            snacks: "小食",
            chinese: "中式",
            western: "西式",
            thai: "泰式",
            vegetarian: "素食",
            bett: "便當",
            area: "地區",
            area1: "中環",
            area2: "北角",
            area3: "銅鑼灣",
            area4: "觀塘",
            area5: "長沙灣",
            area6: "尖沙咀",
            area7: "葵涌",
            area8: "西貢",
            area9: "沙田",
            area10: "荃灣",
            area11: "屯門",
            area12: "元朗"
        },
        blogs: {
            h1: "到會家美食到會指南",
            p: "最新資訊"
        },
        Indexbanner: {
            h1: "屬於香港人的",
            h2: "“ 自選美食到會 ”",
            btn1: "立即選購",
            btn2: "WhatsApp預定"
        },
        Indexcontent: {
            h1: "提供香港到會服務給私人、企業、大型活動",
            span1: "自選到會美食預定",
            p1: "不論是公司或私人聚會，又或其他商務活動宴會等，都歡迎訂購我們的自選到會食物推介",
            btn1: "立即下單",
            imgtag1: "到會家自選1人1到會",
            span2: "活動報價",
            p2: "有關1對1的專人到會，我們也設有報價服務，為您帶來至佳的到會服務推介方案",
            btn2: "立即報價",
            imgtag2: "到會家活動報價",
            span3: "商務合作",
            p3: "我們歡迎任何的商業合作伙伴和模式，成為我們長期的美食到會客戶",
            btn3: "立即報價",
            imgtag3: "到會家商務合作"
        },
        Indexmenu: {
            h1: "適合您的到會推介美食",
            span1: "私人/公司派對到會",
            span2: "商務活動",
            span3: "小朋友生日到會",
            span4: "船P美食",
            span5: "午餐會",
            span6: "茶點"
        },
        IndexText: {
            h2Banner: "一直以來，到會家在多年間為顧客提供多款到會食物推介，並且無間斷地嘗試選新的菜式，新的模式提升其美食到會質素，為客人在口味等經常帶來新鮮感！各類活動包括公司商務宴會、私人聚會，或其他大型活動到會等，統統俱存，務求達至客人心目中至佳的美食到會服務！",
            h2BannerSecond: "改變大眾對傳統香港到會質素參差的印象！到會家的美食到會推介經驗廚師精心設計，味道、香氣與口感均是我們所重視的。我們到會公司希望客人於家中、公司、甚至大型盛宴上都能像在餐廳一樣，吃到愉悅、滿足的味道。",
            h2menu: "美食到會當前讓人眼花繚亂？選擇美食款式往往是一件令人煩惱的事情，特別是即將為多人聚會籌劃餐飲環節，但是如果您懂得根據適合的方向來選擇的話，就是一件非常簡單的事了。選擇到會美食，您可按形式，例如是公司宴會或私人聚餐、飯盒到會服務等；亦可因應不同場合，包括生日會、船P、公司的特別活動聚會，甚至一些戶外野餐等；甚至可按不同的節日，例如新年、復活節、母親節、父親節，還有中秋節、聖誕節，以至萬聖節等皆可。而最後關於食物風味方面，您可按到會食物推介款式以作選擇，無論是西式、中式、泰式、日式，以至素食到會和精緻一口小食等均可。從這類方向開始作選擇、安排，您便能夠更加容易揀選一些至迎合您要求的香港到會美食和服務。",
            hezuo: "香港到會公司邊間好? 到會家擁有多年提供到會服務推介的經驗，曾為超過100萬名客人提供美食到會，無論是私人或公司聚會、船河、公司聚會、商務自助餐、小朋友生日、婚宴、下午茶茶點等均有豐富的服務經驗，絕對為您的到會推介之至佳選擇。另外，到會家更曾為多個香港著名活動及大機構服務而感榮辛，例如AIA友邦、Manulife宏利、FWD富衛香港等，還有香港海關、建造業議會、IFC，以及學府如香港大學等，都是我們到會公司的客戶，合作機構超過400間。我們的到會美食更可送貨至全港18區，讓香港顧客都能夠享用我們的專業到會服務推介。",
            faq: {
                headerTitle: "預訂到會美食 - 常見問題:",
                aboutFoodTitle: "關於預訂美食到會:",
                aboutFood: {
                    faq1: "1. 訂購香港到會的整個程序如何？",
                    content1: "【答】客戶可先在預訂到會美食的頁面一按「網上訂購」，在進入網上自助落單頁面時，便可揀選至合您要求的食品，之後再填送貨地址、用餐日期和時間，當然也要輸入客戶名稱及聯絡電話，最後選擇對你最為方便的付款方式，整個訂購過程便大功告成！",
                    faq2: "2. 最遲可以甚麼時候預訂到會美食？ ",
                    content2: "【答】我們是一年365日全年無休的香港到會服務公司，一般平日我們都會接受最遲提早一天預訂，但為了保持服務及食物質素，我們都會建議客人提早兩至三天預訂。特別是某些日子，例如是一些節日如新年、復活節、母親節、父親節、中秋節、聖誕節，甚至萬聖節等，還有星期六等，我們也建議客人宜提早預訂。特別一提是，我們各類到會食物推介，更大有可能於一些繁忙時段及日子在截單方面會提早一點。",
                    faq3: "3. 到會食物的份量多少？",
                    content3: "【答】到會2磅/5磅的食物外賣盒不等於容納食物後的實際磅數。例如是沙律比飯麵類較輕，兩款食物種類同時裝滿均不等於相同重量。 ",
                    faq4: "4. 我需要預訂多少食物份量？",
                    content4: "【答】請放心，到會家已為客人預先量度好食物份量，設計出適合不同人數的到會套餐，例如10人份量、20人份量、30人份量、40人份量等等，客人可以按派會參加人數揀選相應的套餐。",
                    faq5: "5. 1人1款自選與套餐的分別？",
                    content5: "【答】1人1款自選到會推介可讓每位客人自由揀選自己心水的到會美食，做到每位客人也能夠擁有自己喜歡的食物，從中亦可在聚會與親朋好友分享！而我們的到會服務推介套餐可以讓您根據用餐人數而選擇，例如30人的聚會可以選擇30人的香港到會套餐！多人套餐更提供不同風味的菜式，詳情請瀏覽我們的訂購頁面。",
                    faq6: "6. 到會家的到會菜式與傳統香港到會有何分別？",
                    content6: "【答】傳統香港到會菜式選擇較為單一，來來去去都只有幾道菜可選，而且每款份量多，純粹只為果腹，未能真正享受於聚會中嚐美食的滋味。到會家打破傳統，加入大量新穎的飲食元素，除了西式、中式，亦有泰式，甚至是素食到會。我們作為努力求變的到會公司，每逢時節，如萬聖節、聖誕節、新年，我們會設計及推出相應套餐，帶給客人新鮮感及與別不同的香港到會體驗。憑著各式各樣的到會選擇，我們已經成為眾多客人心目中的到會推介公司。",
                    faq7: "7. 到會家有什麼到會食物推介嗎？",
                    content7: "【答】我們的到會食物均由經驗廚師精心設計，全是心機之作，每款都是到會推介，不能盡錄。如真的要數到人氣到會推介之選，就有西餐到會中的一口迷你漢堡、BBQ醬烤原條豬肋骨、德國香腸拼盤等；泰菜到會有必吃的香辣肉碎生菜包、泰式豬頸肉、手打蝦餅、原隻無骨泰式海南雞等。",
                    faq8: "8. 為什麼到會家是到會推介公司首選？",
                    content8: "【答】我們擁有多年製作香港到會之經驗，曾為無數客人提供美味到會，亦與多個知名機構合作，透過我們的美食到會使活動及聚會更完整美滿。我們明白客人對食物素質及菜式選擇的要求，因此到會家提供多元化的食物選擇，以滿足不同客人的口味。我們一直用心經營香港到會，務求繼續製作出更多到會食物推介。",
                    faq9: "9. 除了到會美食外，到會家還會提供相應的服務嗎？",
                    content9: "【答】特別到會服務推介包括侍應生服務，在重要又盛大的活動中，到會家能安排專業侍應生服務貴賓。除此之外，我們亦提供餐具及餐枱租借、酒水服務、廚師即場烹調等一條龍的附加服務。有到會家的協助，客人在籌備聚會時可更輕鬆更放心，並專注於活動的其他細節上。",
                    faq10: "10. 我可以自行設計到會食物嗎？",
                    content10: "【答】當然可以。到會家明白每位客人對食物的偏好及份量各有不同，因此我們特別提供個人化服務，客人可以透過WhatsApp與到會家專員聯絡，告訴我們您喜歡的到會推介食物，我們會與專業廚師商討，並因應您的需要製作專屬菜式，給您貼心的到會服務體驗。",
                    faq11: "11. 到會家的食品安全嗎？",
                    content11: "【答】當然可以。到會家明白每位客人對食物的偏好及份量各有不同，因此我們特別提供個人化服務，客人可以透過WhatsApp與到會家專員聯絡，告訴我們您喜歡的到會推介食物，我們會與專業廚師商討，並因應您的需要製作專屬菜式，給您貼心的到會服務體驗。",
                    faq12: "12. 到會家能提供任何到會推介或意見給我嗎？",
                    content12: "【答】當然可以。我們明白客人面對林林總總的到會服務推介選項時會不知從何入手，到會家建議客人先從聚會人數、以及菜式開始選擇，我們特別將到會套餐分門別類，客人可從人數及款式此兩大選項篩選出心水到會。我們亦可為客人提供美食到會諮詢服務，由專員了解聚會詳情，再給予適切的訂購建議。",
                    faq13: "13. 如欲了解更多訂購詳情，我可以如何聯絡到會家？",
                    content13: "【答】到會家提供多種聯絡方法，如欲了解更多訂購到會服務詳情，您可透過WhatsApp 6458 6539或電郵至 cateraway.cs@funmaxhk.com 與我們聯繫。"
                },
                aboutPaymentTitle: "關於付款:",
                aboutPayment: {
                    faq1: "1. 預訂到會有甚麼付款方式？",
                    content1: "【答】為了讓客人能夠使用更完善的付款服務享用我們的到會推介，本公司提供了多種付款方式選擇，包括信用卡Visa，Master Card，American Express、PayMe、FPS轉數快、銀行轉帳、Alipay支付寶等等。",
                    faq2: "2. 我可以以現金形式付款嗎？",
                    content2: "【答】很抱歉，到會家現時只接受上題所述的付款方式，並不接受以現金形式付款。",
                    faq3: "3. 我能夠先支付訂金、當日到會送達或自取後繳付餘下金額嗎？",
                    content3: "【答】由於需要提前預備食材及預留人手烹煮食物，到會家要求客人下單時全數付款，並不接受先付訂金後找尾數等安排。",
                },
                aboutDeliverTitle: "關於送貨:",
                aboutDeliver: {
                    faq1: "1. 美食到會全香港、九龍、新界十八區都送貨嗎？",
                    content1: "【答】我們香港到會採用第三方運輸團隊負責食物運送，全港可於路面運送的地區都可以送到。但偏遠地區如禁區、羅湖、沙頭角、迪士尼、機場、海洋公園、愉景灣、西貢北潭涌、黃石碼頭、離島、馬灣、摩口嶺、數碼港、貝沙灣、淺水灣、赤柱、石澳等，則需要額外收取運費或不能運送，詳情請向我們到會公司的客戶服務部查詢。",
                    faq2: "2. 什麼是地面交收？",
                    content2: "【答】如果客人訂購到會美食時揀選「地面交收」，即是司機不會走到大堂來送貨予客戶，而是於車輛可停泊之位置進行交收。當司機快將到達目的地時，會跟客人聯絡。不過，如果司機在送貨時間內多次致電客戶也未聯絡得上的話，並且在到達時間之後的15分鐘內，都未能夠聯絡到客戶、無法進行交收時，送貨司機有權可以：",
                    content2Span1: "1. 如果目的地的大廈有大堂，會將食品寄托給他們作安排",
                    content2Span2: "2. 依據物流平台 (例如Lalamove、GOGOX等) 的收費表，每隔5分鐘來收取等候費，大約為 10至15元不等，完成交收平台會向客人收取這等候費用",
                    faq3: "3. 到會公司能於指定時段送貨嗎？",
                    content3: "【答】可以，請於訂購到會服務時揀選您需要的送貨時段，我們以半小時為一節，即例如2時至2時半、5時至5時半，送貨時段選擇由早上10時至晚上7時半。根據過往經驗，在道路暢通、交通正常情況下，到會一般能依時送達。",
                    faq4: "4. 到會推介包送貨嗎？",
                    content4: "【答】到會服務凡惠顧滿港幣2200元或以上，即可享免費送貨服務(特定日子出外），將軍澳區及偏遠地區除外。若消費未滿港幣2200元之訂單，我們到會公司將收取送貨費用，收費詳情如下：",
                    content4Span1:"僅限觀塘市中心（但不包括牛頭角；秀茂坪；藍田；九龍灣）- 港幣50元",
                    content4Span2: "九龍區－港幣150元",
                    content4Span3: "港島區－港幣220元",
                    content4Span4: "新界區－港幣210元",
                    content4Span5: "特別日子運費（適用於22-27,31/12）:",
                    content4Span6: "九龍區（不包括將軍澳區）- 港幣180元:",
                    content4Span7: "港島區- 港幣220元",
                    content4Span8: "新界區（其他地方如禁區、羅湖、沙頭角、迪士尼、機場、海洋公園及離島等偏遠地區將收取額外運費）- 港幣210元",
                    content4Span9: "偏遠地區將收取額外運費，詳情請與到會家的專員聯絡。",
                    faq5: "5. 到會家有實體店嗎？我能自取嗎？",
                    content5: "【答】可以。在網上下單時，選單將會列出兩種到會送遞方式，分別為「自取」及「送貨」。自取到會的客人可選擇自取日期、自取時間。到會家的提貨地址為香港觀塘開源道62號駱駝漆大廈 1座 12樓 D室。",
                    faq6: "6. 我能授權其他人替我取貨嗎？",
                    content6: "【答】可以。在授權人取貨時，請使用有效的確認訂購證明。客人亦可預先提供授權取貨人的聯絡資料予我們，方便到會家職員核對資料。"
                },
                aboutToEatTitle: "關於用餐:",
                aboutToEat: {
                    faq1: "1. 訂購到會美食會附上餐具嗎？",
                    content1: "【答】我們到會公司會為每張訂單提供適量的餐具數量，每份餐具包含獨立包裝黑色硬身膠叉，濕紙巾，紙碟。如客人需要更多餐具，可以額外購買，只要於下單時輸入額外餐具數量即可。",
                    faq2: "2. 美食到會到達場地後需要即時食用嗎？",
                    content2: "【答】我們到會公司會為每款食物包裝好，務求能長時間保溫，而一般來說，到會食物經我們全面包裝後能保溫大約1小時。為求品嚐得到最溫暖新鮮的美食，我們建議客人在到會到達場地後盡快享用，避免溫度流失。",
                    faq3: "3. 如何提高美食到會食物溫度？",
                    content3: "【答】到會家的到會服務宗旨堅持即煮即送貨，食物溫度溫熱，適合即時享用。若然客人希望進一步提升食物溫度，可自行透過明火或焗爐加熱食物至理想狀態。",
                },
                aboutOrderTitle: "關於更改訂單:",
                aboutOrder: {
                    faq1: "1. 到會套餐裡面的食物種類可以更改嗎？",
                    content1: "【答】到會套餐類型的食物款式均不設更改，如需要更改同款類型的食物，每款需加$100以上的差額。我們更提供特別訂製的到會服務，如有興趣，歡迎向我們到會公司的客戶服務部查詢有關報價。",
                    faq2: "2. 套餐裡面的食物份量可以更改嗎？",
                    content2: "【答】我們明白有客人可能對某款到會食物推介情有獨鍾，希望增加份量，又或是想於套餐上增加整體用餐人數份量，一切都是可行的，請於下單前透過WhatsApp與到會家的專員查詢，讓我們按您的要求提供報價，盡力實現配合您的到會推介。",
                    faq3: "3. 若我訂購到會時，不小心輸入錯誤資料可怎麼辦？",
                    content3: "【答】若發現輸入資料錯誤，請立即致電6458 6539聯絡我們到會公司。我們亦強烈建議客人在正式下單及付款前，檢查所選到會套餐內容，包括食物、份量，以及送遞日期、送遞地址、聯絡資料等。",
                    faq4: "4. 我能夠取消訂單或把訂單延期嗎？",
                    content4Span1: "· 到會家容許客戶取消訂單或將訂單延期，如在訂單確認後欲取消訂單或延遲訂單，請於 3 日前通知，我們到會公司並將會收取 30%手續費。",
                    content4Span2: "· 若顧客於到會日期前少於 3 日通知取消訂單，已付金額將不獲退回。",
                    content4Span3: "· 本到會公司於訂購、細則及條款上保留最終決定權。",
                    faq5: "5. 如遇上惡劣天氣，到會家會怎樣處理我的訂單？",
                    content5: "【答】如到會送貨當日，天文台懸掛八號以上暴風信號及黑色暴雨，香港到會顧客可選擇保留訂單及選擇原訂購日期起 90 天內延期。",
                },
                faq1: "訂購香港到會美食的流程是怎樣？",
                content1: "【答】客人可以在預訂到會美食頁面上選擇“網上訂購“，當進入網上自助落單頁面後，再選擇適合您的食物、然後輸入送貨地址、用餐日期及時間、客人聯絡名稱及電話，最後選擇適合您的付款方式，就訂購完成了！",
                faq2: "最遲可以甚麼時候預訂到會美食？",
                content2: "【答】我們是提供一年365日全年無休的香港到會服務公司，一般平日我們都會接受最遲提早一天預訂，但為了保持服務及食物質素，我們都會建議客人提早兩至三天預訂。如果是週末星期六、或者是其他特別日子例如是新年、復活節、母親節、父親節、中秋節、萬聖節、聖誕節等，都會建議客人提早預訂，我們的所有到會食物推介更有機會在繁忙時段及日子提早截單。",
                faq3: "預訂到會有甚麼付款方式？",
                content3: "【答】為了讓客人能夠使用更完善的付款服務享用我們的到會推介，本公司提供了多種付款方式選擇，包括信用卡Visa，Master Card，American Express、PayMe、FPS轉數快、銀行轉帳、Alipay支付寶等等。",
                faq4: "美食到會全香港、九新、新界十八區都送嗎？",
                content4: "【答】我們採用第三方運輸團隊負責食物運送，全港可於路面運送的地區都可以送到。但偏遠地區如禁區、羅湖、沙頭角、迪士尼、機場、海洋公園、愉景灣、西貢北潭涌、黃石碼頭、離島、馬灣、摩口嶺、數碼港、貝沙灣、淺水灣、赤柱、石澳等，則需要額外收取運費或不能運送，詳情請向我們到會公司的客戶服務部查詢。",
                faq5: "到會食物的份量多少？",
                content5: "【答】到會2磅/5磅的食物外賣盒不等於容納食物後的實際磅數。例如是沙律比飯麵類較輕，兩款食物種類同時裝滿均不等於相同重量。",
                faq6: "套餐裡面的食物種類可以更改嗎？",
                content6: "【答】套餐類型的食物款式均不設更改，如需要更改同款類型的食物，每款需加$100以上的差額。我們更提供特別訂製的餐單服務，如有興趣，歡迎向我們到會公司的客戶服務部查詢有關報價。",
                faq7: "訂購到會美食會附上餐具嗎？",
                content7: "【答】我們到會公司會為每張訂單提供適量的餐具數量，每份餐具包含獨立包裝黑色硬身膠叉，濕紙巾，紙碟。",
                faq8: "1人1款自選與套餐的分別？",
                content8: "【答】1人1款自選到會推介可讓每位客人自由揀選自己心水的到會美食，做到每位客人也能夠擁有自己喜歡的食物，從中亦可在聚會與親朋好友分享！而我們的到會服務推介套餐可以讓您根據用餐人數而選擇，例如30人的聚會可以選擇30人的香港到會套餐！多人套餐更提供不同風味的菜式，詳情請瀏覽我們的訂購頁面。",
                faq9: "取消訂單、更改訂單及訂單延期？",
                content9: {
                    p1: "1. 訂單一經確認後，如需取消訂單或延遲訂單，請於 3 日前通知，我們到會公司並將會收取 30%手續費。",
                    p2: "2. 若顧客於到會日期前少於 3 日通知取消訂單，已付金額將不獲退回。",
                    p3: "3. 惡劣天氣安排：如到會當日，天文台懸掛八號以上暴風信號及黑色暴雨，顧客可選擇保留訂單及選擇原訂購日期起 90 天內延期。",
                    p4: "4.本到會公司於訂購、細則及條款上保留最終決定權。",
                },
                faq10: "什麼是地面交收？",
                content10: "【答】若客人訂購到會美食時選擇「地面交收」，交收時送貨司機不會進入大堂，交收地點會在車輛可停泊位置，司機將接近收貨地點時會聯絡客人。",
                content10_1: {
                    p1: "但司機在送貨時間內致電多次未能聯絡閣下，並且在到達時間後15分鐘內無法聯絡閣下／無法進行交收，送貨司機有權：",
                    p2: "1. 將食物寄托在大堂或管理處 [如有]",
                    p3: "2.  按物流平台 (e.g. Lalamove / GOGOX) 收費表每 5分鐘收取等候費用 $10 - $15，交收後平台會向客人收取等候費"
                }
            }
        },
        hezuo: {
            h2: "我們到會公司的客戶",
            name1: "18+ Central",
            name2: "AIA",
            name3: "東區尤德夫人那打素醫院",
            name4: "東亞銀行",
            name5: "富衛香港",
            name6: "基督教聯合醫院",
            name7: "建造業議會",
            name8: "將軍澳醫院",
            name9: "救世軍",
            name10: "老夫子慈善跑2019",
            name11: "瑪麗醫院",
            name12: "如心酒店",
            name13: "四季酒店",
            name14: "香港城市大學",
            name15: "香港大學",
            name16: "香港復康會",
            name17: "香港海關",
            name18: "香港會議展覽中心",
            name19: "香港科技大學 商學院",
            name20: "香港小童群益會",
            name21: "香港音樂及藝術節",
            name22: "香港中文大學 醫學院",
            name23: "香港足球總會",
            name24: "協康會",
            name25: "醫院管理局",
            name26: "怡和科技",
            name27: "英國保誠+ Prudential",
            name28: "AIA",
            name29: "Amazon",
            name30: "Deutsche Bank",
            name31: "GAP",
            name32: "IFC",
            name33: "Kooza",
            name34: "Maersk",
            name35: "Menulife",
            name36: "PWC",
            name37: "Sports Federation _ Olympic  Committee of Hong Kong",
            name38: "volvo-ocean-race",
            btn: "更多客戶"
        },
        seo: {
            h1: "全港首創自選一人一款到會",
            p1:
                "作為以優質見稱的到會公司，到會家一直以來都積極作融合創新，為廣大客戶提供更高質素的食品和服務。過往我們所見，香港到會服務提供的食物款式相當有限，一般只予十多二十人的聚會享用，但這是完全不足以滿足顧客需要美食種類繁多的喜好，所以導致每位顧客可以食到的到會款式只得很少。",
            p2:
                "我們是全香港首間提供一人一款自選模式的到會公司，在皇牌精選中的每一款食物都是可以任君選擇，即是例如每20人的聚會，每位客人都可以吃到20款不同款式的到會美食，同時可以滿足到在場不同顧客的口味。除了美食到會以外，我們還會提供一系列其他到會服務推介。",
            p3:
                "我們的到會服務還包括提供專業侍應生服務，亦可以安排廚師即場烹調、並且有餐具及餐枱租借等等一條龍的附加服務。不管是什麼類型的客戶，如果您想要優質的到會服務推介，我們都能夠提供多元豐富的到會食物推介。我們曾作不同類型活動的到會服務，婚宴固然是其中之一，生日會亦不例外，還有其他如公司開張慶典、公司會議、運動會，以至中環的多項大型活動等不同類型到會服務。我們明白每位客人都希望吃到心目中的美食，因此如果客人想為自己的活動訂製美食到會，我們都會樂意為您提供專人一對一的到會報價服務，務求令到您的在食物方面達到極致的體驗，從而滿足您的獨特要求。"
        },
        halloweenweb: {
            h1: "萬聖節到會",
            h2: "到會家為你提供專屬萬聖節的到會美食",
            btn: "Order Now",
            section1h2: "令萬聖節派對更添氣氛",
            section1p:
                "一年一度Halloween party，又係扮鬼扮馬，嚇親朋友嘅時候啦！大家都會趁此機會悉心打扮，穿起奇裝異服和古靈精怪的群魔面具，盡情放肆作怪。舉行派對的話，當然少不了一系列應節的萬聖節派對食物，可以醫肚餓之餘，更能令整個萬聖節活動的氛圍昇華，你一定唔可以錯過這個年度佳節！",
            section2h2: "萬聖節到會必選食物",
            section2h3_1: "鬼馬蜜糖南瓜蕃薯",
            section2h3_2: "萬聖朱古力布朗尼",
            section2h3_3: "巫婆一口香蕉軟心配紫薯波",
            section2p1:
                "萬聖節不能缺少嘅蔬菜類！新鮮清甜的南瓜蕃薯搭配香濃絲滑嘅蜜糖，簡直係Perfect match！啱曬係大型節日都要追求健康嘅你地。",
            section2p2:
                "主題色嘅朱古力布朗尼，造型精緻，味道獨特。響應出節慶嘅美妙滋味！我都想即刻整返舊啊！",
            section2p3:
                "顏色誘人，香脆絲甜嘅香蕉軟心，再配襯滿佈燕麥嘅紫薯波，真係大人細路都咁鍾意啊！",
            section3h2: "度身設計你的萬聖節派對到會",
            section3p:
                "到會家由擁有超過三十年的豐富烹飪經驗的主廚主理，為您製作萬聖節派對美食。我們更樂意根據您的要求，度身設計屬於您美食。務求能令您享受豐富的萬聖節大餐到會服務，體驗樂而忘返嘅萬聖節派對！",
            tip: "凡訂購14盤到會美食以上，即送意式朱古力雲呢拿泡芙一客！"
        },
        corporatebanner: {
            h: "讓我們成為您的合作伙伴",
            p: "我們與超過200+不同類型公司長期合作，保證提供最優質的服務",
            btn: "聯絡我們"
        },
        corporatecontent: {
            title:"公司到會",
            subTitle:"我們與超過200+不同類型公司長期合作，保證提供最優質的到會服務",
            h: "讓我們成為您的合作伙伴",
            span1:
                "我們與超過100+的Partyroom有著合作關係，為他們的客人提供性價比極高的服務。如果有去Partyroom的朋友，相信都會嘗試過我們的美食",
            span2:
                "我們一直以來都有和不同的活動策劃公司合作，之前曾多個中環的大型活動包括AIA嘉年華、Clockenflap、公司開幕禮及酒會、建造業議會馬拉松等的活動提供美食",
            pic2: "活動策劃公司",
            span3:
                "我們亦與不少的小朋友主題場地合作，因為我們的美食十分適合小朋友和大人共同進食。過去我們亦曾為不少的小朋友畢業禮、小朋友生日會提供這類公司到會服務",
            pic3: "小朋友活動公司",
            span4:
                "我們亦和健身院共同研發健身餐單，所有的健身餐均含有足夠的營養和蛋白質，為健身人士帶來運動後的補給",
            pic4: "健身院",
            span5:
                "我們亦是醫管局的長期合作伙伴，每天我們都會為相關部門提供美味午餐，在食物安全及品質控制方面均有信心保證",
            pic5: "醫管局",
            span6:
                "我們公司有自設食物工場，廚師亦熟悉多國食物的製作方法，有為不同的餐廳提供半製成品及全製成品，提供餐廳的效率",
            pic6: "餐廳",
            btn: "聯絡您的夥伴",
            seoh1: "公司到會最佳夥伴",
            seop1:
                "到會家多年來服務超過300家公司到會，不少公司選擇到會家的原因是性價比高，乎合公司預算，及食物的質素高，上司和同事都十分滿意。我們服務公司到會的類型包括公司開幕禮、週年晚會、記者招待會、公司發佈會、公司聯歡會及公司商務晚會。到會家的公司到會服務形式包括廚師上門即制、自助餐、finger food 及 canapes，餐酒方面，我們可以提供紅酒、白酒及雞尾酒。另外還設有爐具及西式餐具租借，為您的活動提供更完整的服務",
            seop2:
                "另外，一些公司的活動可能是比較大型的活動，包括嘉年華、馬拉松及公司大會，我們在這一方面都是經驗豐富。我們曾提供公司到會食物予中環AIA嘉年華、Clockenflap、太陽馬戲團、18+成人展、老夫子馬拉松等等的活動，而我們亦是各大型企業的公司到會食物提供者，包括Google、匯豐銀行、德意志銀行、AIA保險公司等。不少客人對我們的公司到會滿意度極高，而且更是不同節日的公司派對食物首選，現在就立即為您的公司訂購不一樣的美食吧！",
            seop3:
                "公司到會推介：商務套餐、商務高級自助餐、Deluxe精緻套餐、午餐會自助餐及尊貴午餐自助餐\n",
            seop4: "",
            seop5: "",
            seop6: "",
            seop7: "",
            seop8: "",
            dialog: {
                h1: "聯絡我們",
                namelabel: "稱呼",
                nameplaceholder: "請輸入您的稱呼",
                emaillabel: "電郵：",
                emailplaceholder: "請輸入電郵",
                phonelabel: "聯絡方式",
                phoneplaceholder: "請輸入聯絡方式",
                conlabel: "公司",
                conplaceholder: "請輸入公司名稱",
                coolabel: "合作形式",
                cooplaceholder: "請輸入合作形式",
                btn1: "確 定",
                btn2: "取 消"
            }
        },
        party: {
            h: "派對及小食到會",
            p: "Party到會美食服務超過100+ 不同大小活動",
            btn: "立即選購",
            contenth1: "別具特色的派對到會",
            contentspan1:
                "與親朋好友一起開Party時，很多時候都會覺得好肚餓。唔想即興地隨便在街上買快餐或外賣就敷衍了事？其實開Party時都可以預訂派對美食，例如小朋友party到會。我們為您提供 60+多款中、西、泰及日式的精選派對到會美食，多國菜式那個迎合不同類型的親朋好友。派對到會更可以根據當日派對人數而讓您自由任選食物份量，令您在開Party的過程之中享受派對到會美食帶來的愉悅。",
            contenth2: "度身設計派對食物，切合您的需要",
            contentspan2:
                "我們特別為派對到會設計特色菜式，這些菜式是參考以往的派對到會的經驗而精心設計的，絕對適合與一眾好友享受派對美食。另外，我們更可以根據您的心中的要求，為您度身訂製派對到會菜式。如果您有額外的派對食物要求，我們都可以為您特意烹飪，只要您想得出的美食，我們都會為您製造得更好更美味。",
            lasth1: "立即訂購到會家為您提供的派對美食到會",
            contextTitle: "立即訂購到會家為您提供的派對美食到會",
            context: {
                h2TitleOne: "擁有豐富製作Party到會的經驗",
                pContentOne: "我們是市場上屈指可數的領導者。在香港，我們固有的Partyroom場地合作伙伴超過150間，有不少首次接觸會家食物的客人均是於派對場合上，對我們的食物評價正面，及後再向職員查詢我們的聯絡方式，希望把這份吃到美食的快樂帶回家中及公司，讓其他親朋好友都可以感覺到。除了一般的partyroom，我們還與不同的小朋友場地提供者合作，因為我們的所提供的小朋友party到會都是可以滿足小朋友的選擇，我們設有兒童餐等等，令到成人的客人吃得開心同時，小朋友都可以吃得健康和美味。",
                h2TitleSecond: "不同派對食物任你選擇",
                pContentSecond: "一提到傳統派對食物，總不外乎pizza和炸雞等等，鮮有「party到會」的想法，但隨著市場發展，派對食物類型層出不窮，愈來愈多創新食品。到會慢慢從公司帶到家及其他聚會的地方，因此我們的一人一款派對食物是更能滿足到客人的需求，令到他們在不同的Party上，無論是在家、會所還是公司，都有一份全新的美味和多選擇的沖擊。在公司Party到會方面，部份客人都會選擇我們的原因是我們除了一般的菜式以外，我們還會設有finger food 和 canapes 等的食物，滿足更高級的享受。",
            },
            aboutPartyTitle: "關於訂購Party到會 - 常見問題:",
            aboutParty: {
                faq1: "1. 為何選擇我們的party到會？",
                content1: "我們擁有豐富製作派對食物的經驗，曾服務超過100個派對美食活動。我們所製作的party到會有別傳統，非常多元，部分菜式更來自日本、泰國等地，為客人帶來與別不同的新鮮感。",
                faq2: "2. 到會家的小朋友party到會與一般服務有什麼不同？",
                content2: "設計小朋友party到會套餐時，我們的廚師特別考慮到小朋友的飲食喜好，如喜歡吃小食、甜品，因此在小朋友party到會菜式上涵蓋多款美味小食如一口台灣小香腸、香脆墨魚角，還有孩子最愛的彩虹椰絲啫喱糖、朱古力雲呢拿泡芙等。而同時考慮到飲食均衡這項要點，除了小食與甜品外，餐單中還會有沙律及炒雜菜等健康選擇，讓小朋友吃得開心之餘，家長又放心。",
                faq3: "3. 我有喜歡的派對食物，可以放進餐單中嗎？",
                content3: "當然可以！辦派對當然要選自己喜歡的食物，我們提供度身設計餐單服務，歡迎您告訴我們您心目中的菜式要求，我們團隊會盡力配合，為您設計出專屬又可口的party到會菜單。"
            },
        },
        kwun: {
            h: "觀塘、牛頭角、九龍灣到會",
            p: "到會家服務超過100+公司 為企業度身訂做到會美食",
            btn: "立即選購",
            contenth1: "觀塘、牛頭角、九龍灣到會",
            ctitle1: "觀塘、牛頭角、九龍灣大機構選撰的專業到會",
            ctitle2: "度身設計，適合你的要求",
            contentspan1:
                "觀塘、牛頭角、九龍灣這三個地方為觀塘商貿區。該地區工商業大廈林立，地理位置優越，因而受到很多投資者的青睞，在這個地方設置公司或機構。不少公司例會、典禮、派對、講座都需要精緻的到會美食作為陪襯的角色。而到會家則代表這個角色的橋樑，為公司或機構提供適合不同場合的多元化到會美食。",
            contentspan2:
                "到會家提供多種商務活動美食到會服務供您選擇，包括多人Deluxe精緻套餐、商務皇牌自助餐、公司開幕自助餐、商務午餐自助餐、多人茶聚套餐等等。亦可以根據您的需求度身訂製到會美食，為您製作獨一無二的盛宴。我們亦為觀塘、牛頭角、九龍灣的Party room精心設計派對到會餐單，務求令客人玩得開心、食得開心。s",
            contentspan3:
                "特意聘請三十年經驗的西式廚師為您炮製美食，值得信賴。除了精緻的婚禮到會美食，我們也提供熱爐、侍應、酒水餐具和場地佈置等服務。到會家曾服務超過100+企業或機構，多年黎一直屹立不倒，絕對是到會的首選。"
        },
        event: {
            bannerh1: "活動餐飲報價",
            bannerh2: "到會家服務超過100+ 不同大小的活動",
            bannerbtn: "提交活動需求",
            contenth1: "報價服務",
            contentp1: "告訴我們您的活動，讓我們為您提供最佳美食",
            contentspan1: "定制屬於您的活動美食",
            contentsam1:
                "請將您的活動要求發給我們，我們會根據你的活動定制最適合您的食物",
            contentspan2: "1對1專人服務",
            contentsam2: "我們會有專人1對1服務您的活動，保證最優質的服務體驗",
            contentspan3: "多款活動類型經驗",
            contentsam4:
                "我們曾提供美食給不同大小型活動，包括中環AIA嘉年華、Clockenflap、建造業馬拉松賽事及公司開幕",
            changetitle1: "大型活動",
            changetitle2: "商務活動",
            changetitle3: "過年活動",
            changetitle4: "午餐會議",
            change1: "自助餐",
            change2: "廚師即制",
            change3: "運動員補充",
            change4: "Canapés 服務",
            change5: "午餐會",
            change6: "Canapés",
            change7: "午後茶點",
            change8: "公司開幕",
            change9: "自助餐",
            change10: "菜餚＋餐酒",
            change11: "中式圍餐",
            change12: "Canapés 和雞尾酒會",
            change13: "西式自助餐",
            change14: "便當",
            change15: "茶點自助餐",
            change16: "小食拼盤",
            dialog: {
                h1: "聯絡方式",
                h2: "活動詳情",
                namelabel: "稱呼",
                nameplaceholder: "請輸入您的稱呼",
                emaillabel: "電郵",
                emailplaceholder: "請輸入電郵",
                phonelabel: "聯絡方式",
                phoneplaceholder: "請輸入聯絡方式",
                conlabel: "公司",
                conplaceholder: "請輸入公司名稱",
                date1label: "日期",
                date1placeholder: "請選擇日期",
                date2label: "時間",
                date2placeholder: "請選擇時間",
                locationlabel: "地點",
                locationplaceholder: "地點",
                numberlabel: "貴賓人數",
                budgetlabel: "預算",
                budgetplaceholder: "請輸入預算",
                foodlabel: "所需食物",
                foodplaceholder: "請輸入所需食物",
                region1label: "食物供應形式",
                region1placeholder: "自助餐、飯盒...",
                Drinklabel: "飲品",
                Drinkplaceholder: "請輸入所需飲品",
                Waiterlabel: "待應生",
                Waiterplaceholder: "待應生",
                region2label: "設備要求",
                region2placeholder: "長枱、熱爐...",
                Claimlabel: "特別要求/安排",
                Claimplaceholder: "請輸入特別要求/安排",
                btn1: "確 定",
                btn2: "取 消"
            }
        },
        contact: {
            banner: {
                h: "全新的到會體驗",
                p: "我們致力為舉辦不同活動的您提供最優質及價格便宜的到會美食服務"
            },
            content: {
                title: "聯絡我們",
                phone: "電話：64586539",
                whatsapp: "WhatsApp: 64586539",
                address: "地址：香港觀塘開源道62號駱駝漆大廈1座12樓D室",
                email: "電郵：cateraway.cs@funmaxhk.com",
                title2: "查看我們的社交平台"
            }
        },
        menu: {
            title: "情人節精選套餐",
            title1: "父親節限定套餐",
            btn1: "WhatsApp預訂",
            btn2: "立即選購",
            banner: {
                h: "全新的到會體驗",
                p: "我們致力為舉辦不同活動的您提供最優質及價格便宜的到會美食服務"
            },
            mainMenuTitle:"到會服務推介菜單",
            span: {
                title1: "70+",
                content1: "超過70款到會食物推介",
                title2: "400+",
                content2: "我們為超過400間公司提供到會服務",
                title3: "1,000,000+",
                content3: "我們到會公司已服務超過100萬位客人",
                title4: "點對點交收",
                content4: "我們提供到會送貨上門服務"
            },
            h2: "自選到會餐單，總有一款適合你",
            seo: {
                h1: "到會餐單",
                h2: "平價到會",
                span1:
                    "到會家在餐單設計方面一直都沿用著創新的思維和方法，每一款食物都經過多次試驗，為求您的活動可以變得更完美。到會家在設計每一款的到會餐單的時候，都是由我們的中式廚師、西式廚師及泰式廚師代表共同開發，而每一位廚師平均都是有最少10年的廚房經驗，因此不少客人都是對我們的餐單十分滿意。客人都認為我們的餐單菜色是十分平均和有各國食物的特色。而且我們還有不同類型的素食，滿足香港一眾素食者的需求。到會家在到會餐單設計方面一直都沿用著創新的思維和方法，每一款食物都經過多次試驗，由十多年經驗中式及西式大廚主理，並特意誠邀泰國名廚協助製作出香港一眾素食者的喜愛。",
                span2:
                    "另外我們有不同的到會類型，包括私人派對、商務派對、小朋友生日會、船P到會及午餐會等等活動類型的到會餐牌，一些餐牌都是只需約$82/位就可以品嚐美味的到會。而且每一款到會類型的餐單，我們都會有相對平價到會，令您可以跟據您的活動選擇適合的到會平價美食。在每一份的到會餐單中，我們會跟據客人的活動形式加設對應的到會服務，例如在午餐會中，我們可以提供侍應生服務客人、及對應的酒水等等餐單要求。"
            }
        },
        christmas: {
            titleZH: '屬於香港人的 自選美食到會',
            h1: "聖誕到會",
            h2: "到會家為您的聖誕派對提供專屬聖誕到會美食",
            btn: "立即選購",
            section1h2: "讓你享受難忘的聖誕氣氛",
            e: {
                "h2": "聖誕到會限定餐單",
                "h22": "(聖誕餐單所提供的食物將於12月開始供應)",
                "h3": "聖誕火雞甜品樣樣齊",
                "h33": "全港九新界都送",
                "btn": "立即預訂"
            },
            section2h2: "聖誕節到會必選食物",
            section2h3_1: "聖誕西西里茄茸海鮮燴寬條麵",
            section2h3_2: "聖誕必食原隻烤火雞",
            section2h3_3: "聖誕芝味水牛城雞翼",
            section2p1:
                "甜酸兼備嘅西西里鮮茄醬汁，搭配鮮甜可口嘅海鮮拍檔，再遇上手工寬條麵，真係未聖誕先興奮啊！",
            section2p2:
                "令人興奮又垂涎欲滴的火雞，肉質鮮嫩，味道純厚可口，老少皆宜。既適合高檔餐桌，亦可滿足多人聚會，是聖誕到會的必點之選！",
            section2p3:
                "聖誕嘅氣溫咁寒冷，梗係要嘆返熱辣辣的水牛城雞翼啦！這位美式雞翼嘅代表，憑藉火辣惹味的醬汁配備濃情化不開嘅芝士。嘩，真係好邪惡呀！",
            section3h2: "度身訂製您的聖誕節派對到會",
            section3p:
                "提提您，記得提早預訂我們的聖誕到會推介食物，因為有些日子真的是售完即止喔！",
            tip: "立即選購到會家為您設計的聖誕到會！",
            whatsapp: "WhatsApp 查詢",
            context: {
                h2TitleOne: "一年一度聖誕到會，美食必不可少",
                pContentOne: "我們會設計限定的聖誕到會菜式，這份餐單上的食物，大部份都是只出現在聖誕這個特別的日子中，所有不要錯過在聖誕節期間找我們落單！我們今年的聖誕節到會，會在12月1日開始至到12月31日，將聖誕節氣氛帶到整個月。聖誕節火雞更是必吃的食物，我們的火雞是經由具30年西式菜式經驗的廚師親自主理，聖誕餐單的設計更是加入了聖誕元素，您會不難發現在食物中會見到不少的聖誕主題的食物，包括聖誕原隻燒火雞、聖誕乳酸爆珠雜果沙律、聖誕cupcake，聖誕限定火雞沙律配蕃茄莎莎醬、聖誕糖果麵包布丁等等，為您的聖誕美食帶來更濃厚的氣氛！",
                pContentOneSecond: "提提您，記得提早預訂食物，因為有些日子真的是售完即止喔！如果是公司的客戶，就更加要早一點預訂，不然會給您的上司責備為什麼沒有好吃的食物過聖誕節！如果您有朋友和您一起過聖誕節，就記得為您的朋友們預早訂聖誕到會迎接節日來臨！"
            },
            aboutChristmasTitle: "關於訂購聖誕到會 - 常見問題:",
            aboutChristmas: {
                faq1: "1. 有什麼必吃的聖誕到會菜式？",
                content1: "傳統聖誕大餐必食食物一定要數到火雞，只要端上火雞於餐桌上，即時能感受到滿滿的聖誕氣氛。",
                faq2: "2. 我們的聖誕到會有什麼招牌菜式？ ",
                content2: "我們提供聖誕必吃的原隻燒火雞，還有非常惹味的水牛城雞翼、海鮮寬條麵等等。",
                faq3: "3. 訂購我們的聖誕到會有什麼需要注意？",
                content3: "在這個歡欣的節日裡，不少人都會舉行派對並預訂聖誕到會招呼親朋戚友。而為保持質素，我們在每個日子會製作限定數量的聖誕到會，售完即止。為免落空，謹記提前預訂！"
            },
        },
        christmase: {
            "h2": "聖誕到會限定餐單",
            "h22": "(聖誕餐單所提供的食物將於12月開始供應)",
            "h3": "聖誕火雞甜品樣樣齊",
            "h33": "全港九新界都送",
            "btn": "立即預訂"
        },
        christmase2: {
            "h2": "聖誕精選小型Party到會餐單",
            "h22": "(聖誕餐單所提供的食物將於12月開始供應)",
            "h3": "4-6人套餐運費全免",
            "h33": "啱曬係屋企開Party嘅你地",
            "btn": "立即預訂"
        },
        birthday: {
            banner: {
                h: "生日到會",
                p: "到會家服務超過100+ 不同大人、小朋友生日會",
                btn: "到會預定"
            },
            content: {
                h: "生日到會",
                span1:
                    "到會家主營多年小朋友生日到會，小朋友的餐單設計加入了多款美味及健康的小朋友食物，目的是令到家長們在為小朋友主辦生日派對的時候，小朋友都可以吃得開心和健康。與此同時，家長們亦有自選區可以選擇另類風味的滋味到會。",
                span2:
                    "我們的小朋友區食物以健康和少油少糖少鹽為主，食物包括素芝士藜麥蕃茄沙律、鮮蜜瓜及哈蜜瓜串、瑞士無激素雞中翼、翠肉瓜蛋白炒糙米飯及蒸南瓜蕃薯（配天然原蜜）等等。我們為了小朋友的健康著想，加設鮮茄手打肉丸意大利麵，這款麵的特色是全人手打及完全沒有內臟肉，不像外面一般到會公司的肉丸般，加入不同的部位及內臟打造而成。另外我們的餐單更加入無激素的肉類及蛋類食物，更為小朋友在生日中吃得開心的過程中，健康可以得到保障！",
                span3:
                    "到會家絕對是小朋友生日時的食物推介首選，為您的小朋友生日會提供性價比高、美味及健康的到會食物！家長們快點為您們家的寶貝與辦一個難忘的生日會。"
            },
            context: {
                h2TitleOne: "大人、小朋友生日會，享受美味健康食物",
                pContentOne: "我們主營大人、小朋友生日到會多年，特別於小朋友到會餐單中加入多款美味及健康的小朋友食物，目的是令到家長們辦小朋友生日會時，小朋友都可以吃得開心和健康。與此同時，家長們亦有自選區可以選擇另類風味的滋味食物。",
                h2TitleSecond: "小朋友生日到會 健康最重要",
                pContentSecond: "我們的小朋友區食物以健康和少油、少糖、少鹽為主，食物包括素芝士藜麥蕃茄沙律、鮮蜜瓜及哈蜜瓜串、瑞士無激素雞中翼、翠肉瓜蛋白炒糙米飯及蒸南瓜蕃薯（配天然原蜜）等等。我們為了小朋友的健康著想，加設鮮茄手打肉丸意大利麵，這款麵的特色是全人手打及完全沒有內臟肉，不像外面一般到會公司的肉丸般，加入不同的部位及內臟打造而成。另外我們的餐單更加入無激素的肉類及蛋類食物，更為小朋友在生日中吃得開心的過程中，健康可以得到保障！",
                h2TitleThird: "快速下單 點對點送貨",
                pContentThird: "我們絕對是小朋友生日時的食物推介首選，為您的小朋友生日會提供性價比高、美味及健康的食物！家長們無需花時間準備食材親自下廚，所有生日會食物將交由我們為您一一辦妥。而再進一步減省各位家長的煩惱，我們提供方便快捷的訂購方法，您可以透過網上下單，或是以WhatsApp與我們的專員聯絡，只要告訴我們欲訂購之食物內容、聯絡方法、送貨地點等資料，豐盛的生日到會就會於指定日子送到府上，您將無需為準備孩子的生日會食物而感到懊惱。家中的孩子正期待著吧？各位家長們，趕緊為您們家的寶貝舉辦一個難忘的生日會吧！",
            },
            aboutBirthdayTitle: "關於訂購聖誕到會 - 常見問題:",
            aboutBirthday: {
                faq1: "1. 為何選擇我們的生日到會？",
                content1: "我們的生日到會不單單只是供應食物，我們的廚師於設計菜式時費盡心思，例如在為小朋友生日會製作套餐時，盡量加入少油、少糖、少鹽食物，亦會使用無激素的肉製品及蛋類食物，讓孩子能吃到健康又美味的食物。",
                faq2: "2. 我們的生日到會只適合小朋友生日會？ ",
                content2: "當然不是，雖然我們的生日到會餐單有專為小朋友而設的菜式，但同時我們亦有提供傳統生日到會必吃的推介食物，例如不同味道的雞中翼、意粉、炒飯、三文治等等，任君選擇，大人小孩都適合。",
                faq3: "3. 我們的生日到會適合多少人食用？",
                content3: "我們的生日到會套餐種類多元，適合不同規模的小朋友生日會，少至10人、到20人、30人、40人，甚或是多達60人的聚會，我們都有相應的套餐供應，總有一款適合您。",
                faq4: "4. 哪些場合適合訂購生日到會？",
                content4: "除了家長們為孩子舉辦的小朋友生日會外，其他場合如校園、教會或公司要舉辦生日派對，亦可以選擇向我們訂購生日到會，交由我們為您辦妥派對中所有膳食需要，而您能專注於規劃派對其他細節，無需操心。"
            },
        },
        junk: {
            banner: {
                h: "船河派對到會",
                p: "提供超過100+ 不同大小船p到會",
                btn: "立即選購"
            },
            content: {
                h: "船河到會",
                span1:
                    "每年一到6月至8月，就係大家去船P和開party的大節日！想必您在暑假都會最少開Party 3次呢！每次開船河Party，您們都會叫平價到會上船吃，但應該不難發現，您們叫的船河到會食物大部份都是大大盤，而且一大班人都是吃幾款至十款的食物！選擇少和食物口味單一必定是您上一次船P的回憶吧！但是如果您選擇了到會家，您就可以品嚐到30人30款的超美味和平價到會，不會再擔心款式少的問題。",
                span2:
                    "到會家推薦船p到會食物包括：BBQ蜜糖香蒜炸雞翼、炭燒豬頸肉伴醬燒雞扒、日式炭燒雞肉串、法式紅酒雜菜燴牛腩、意式朱古力雲呢拿泡芙、煙鴨胸青瓜雜菜沙律配蕃茄沙沙醬、日式胡麻三色冷烏冬、卡邦尼煙肉長通粉及西西里鮮茄雜菌墨魚燴意粉等等，建議您們如果是船P搞手的話，就記得為您的Party選擇更多的小食，因為可以令到大家吃得更開心！",
                span3:
                    "到會家的運送地區是基本上所有的碼頭都可以送到，包括觀塘碼頭、西貢碼頭、尖沙咀碼頭、西環碼頭等等，為您的派對送上最滋味的食物！"
            },
            main_section1: {
                h2: "親朋戚友開船P必食到會套餐",
                h3: "10 - 30人船P到會套餐，應有盡有！",
                h4: "預訂聖誕派對到會大餐",
                h5: "多人Party無煩惱！",
                btn: '立即訂購',
            },
            main_section2: {
                h2: "船P到會必食之選",
                meun1: "經典凱撒田園沙律",
                meun2: "香蒜蜂蜜BBQ炸雞翼",
                meun3: "德國脆炸鹹豬手",
                p1: "一塊塊新鮮爽口的羅馬生菜，加上香口酥脆的麵包方粒，混和著惹味煙肉碎，再搭配經典的凱撒沙律醬，每一口都是滋味無窮，絕對適合船P派對享用！",
                p2: "去船P派對點可以少得香蒜蜂蜜BBQ炸雞翼，滋味蜜糖配搭著肉質鮮嫩的雞翼，簡直是天生的一對啊！大人細路都啱食，是船P到會的必點之選！",
                p3: "我們招牌菜之一，德國脆炸鹹豬手，外皮被炸到脆卜卜，肉質細嫩幼滑，入口就肉汁豐盈，趁船P派對的好機會與朋友分享美味把！",
                btn: '立即預訂',
            },
            context: {
                h2TitleOne: "出海前預訂船河到會",
                pContentOneFirst: "每年一到6月至8月，就係大家去船P和開party的大節日！想必您在暑假都會最少開Party 3次呢！每次開船河Party，為求方便快捷，不少人都會叫平價食物上船吃，但應該不難發現，市面上大多數船河到會食物份量都是大大盤，而且一大班人都是吃幾款至十款的食物！選擇少和食物口味單一必定是您上一次船P的回憶吧！其實，船河到會是可以很豐富、很滋味的，如果您選擇了我們的船河到會，您就可以品嚐到30人30款的超美味食物，不會再擔心款式少的問題。",
                pContentOneSecond: "我們推薦船P到會食物包括：BBQ蜜糖香蒜炸雞翼、炭燒豬頸肉伴醬燒雞扒、日式炭燒雞肉串、法式紅酒雜菜燴牛腩、意式朱古力雲呢拿泡芙、煙鴨胸青瓜雜菜沙律配蕃茄沙沙醬、日式胡麻三色冷烏冬、卡邦尼煙肉長通粉及西西里鮮茄雜菌墨魚燴意粉等等。如果您是船P搞手，不妨考慮預訂我們的船P到會，讓我們為您們即將舉辦的船河派對呈獻更多元的小食，吃得開心盡興！",
                pContentOneThird: "我們的運送地區是基本上所有的碼頭都可以送到，包括觀塘碼頭、西貢碼頭、尖沙咀碼頭、西環碼頭等等，為您的派對送上最滋味的食物！",
            },
            aboutJunkTitle: "關於訂購船河到會 - 常見問題:",
            aboutJunk: {
                faq1: "1. 我們的船P到會有何特別之處？",
                content1: "我們的船P到會除了提供各式各樣的人氣主食外，更特別於餐單加入了新鮮沙律及冷盤，讓客人於炎炎夏日裡，能吃著透心涼的消暑美食，盡情享受船河派對。",
                faq2: "2. 我們的船P到會可供多少人食用？",
                content2: "我們特設多款船河到會套餐，例如適合10至12人的歡樂船P到會套餐、20人份量的豐盛船河到會套餐，甚至可供30人食用的船河到會套餐，客人可根據派對參加人數而選擇訂購合適的套餐。",
                faq3: "3. 我們的船P到會提供送貨服務嗎？",
                content3: "我們特別提供船河到會送餐服務，方便將要出海舉行派對的朋友們。我們的送貨範圍涵蓋香港不同地區碼頭，例如西貢碼頭、尖沙咀碼頭，歡迎聯絡我們了解更多。",
            },
        },
        wedding: {
            banner: {
                h: "婚禮到會",
                p: "服務超過100+ 不同大小的婚禮活動",
                btn: "立即選購"
            },
            content: {
                h: "婚禮到會推介更美好的食物，量身定做套餐",
                ctitle1: "為新人選撰的專業婚禮到會",
                ctitle2: "度身設計，專屬給您",
                span1:
                    "每個婚禮都總會有一個關於食的環節，這是一個眾所周知的事實。時至今日，婚禮到會已經演變成接待賓客好重要的一環。一場溫馨及甜蜜的戶外婚宴，除了決定婚禮主題及戶外婚禮場地佈置，招待親友的美食及小食甜品同樣是婚宴重點！新人都會花盡心血物色平靚正婚禮到會，務求食物得體精緻又好食，與主題相呼應，也突顯您的獨有品味。精緻的婚禮到會，一定會令您的婚宴大大加分！",
                span2:
                    "我們為婚禮到會設計了一系列的餐單，這些菜式是由我們的廚師憑著多年婚禮到會製作經驗而精心設計的，可謂新人們推介婚禮必備的美食。另外，我們更可以根據您的心中的要求，為您度身訂製菜單。或者如果您有自定義的食物，我們都可以為您特意烹飪，只要您想得出的美食，我們都會為您製造得更好更美味。",
                span3:
                    "我們是不少新人選用的婚禮到會推介，擁有豐富經驗，由超過三十年經驗的廚師為您製作婚宴美食，值得信賴。除了精緻的美食，我們也提供自助餐保溫熱爐、酒水香檳、侍應服務等服務。我們過往為無數客人提供華麗體面的婚禮到會服務，務求為您的人生里程碑與一個難忘的盛宴結合起來。"
            },
            context: {
                h2TitleOne: "婚禮到會，經驗豐富",
                pContentOneFirst: "我們公司成立多年，亦都很有幸可以見證了很多對新人結婚。現在結婚的新人愈來愈多是走著西方文化的婚禮。每每都是請了一班親朋好友，在一個充滿花草和西式氣氛的環境下舉行婚禮。而新人們會訂一些精美的菜式，不像中式般一圍圍坐底慢慢吃中式食物，而是大家舉起酒杯，拿著一杯杯的精美食物交談和分享新人的喜悅。西式的wedding party正是以美酒配佳餚來慶祝，所以婚禮到會方面是需要更著重食物的配搭！",
                pContentOneSecond: "而我們正是在婚禮到會這一方面是有豐富的經驗，設計很多的餐單是符合您的婚禮party，另外我們還可以與您進行一對一的訂制服務，可以根據您的婚禮到會推介更美好的食物，或者如果您有想要的wedding美食，我們都可以烹飪出來。只要您想得出的美食，我們都會設計得更好和更美味。",
                pContentOneThird: "我們推薦給您的食物包括: 巴馬火腿露荀卷、鮮蝦芒果他他杯、香草鮮野菌生菜杯、甜蝦蕃茄莎莎杯、迷你蝦肉小漢堡、迷你三文魚生菜沙律牛角酥及法式精緻小甜點拼盤。",
            },
            aboutWeddingTitle: "關於訂購婚禮到會 - 常見問題:",
            aboutWedding: {
                faq1: "1. 為何我們是首選的婚禮到會推介？",
                content1: "我們擁有多年製作婚禮美食的經驗，質素與味道是我們認為最重要的兩大關鍵，我們用心準備每一張訂單、每一道菜式，務求給予客人完美的餐飲體驗。除美食外，我們還提供更多貼心服務，包括保溫熱爐為食物保暖、酒水香檳選擇等等。",
                faq2: "2. 我們有什麼婚禮到會推介食物？",
                content2: "婚禮食品必須美味、精緻，能吸引食客，我們特別設計各種賣相體面又可口的婚禮小吃，婚禮到會推介食物包括: 鮮蝦芒果他他杯、迷你蝦肉小漢堡、法式精緻小甜點拼盤等等。",
                faq3: "3. 我們提供婚禮到會自訂服務嗎？",
                content3: "為求盡善盡美，不少新人都希望加入自己喜歡的菜式於餐單中，因此我們提供一對一訂制服務。我們專業團隊將聆聽您的需要，盡力為您設計出一道道婚宴美食。",
            },
        },
        snacks: {
            banner: {
                title: "到會小食",
                subTitle: "服務超過100+不同大小的活動"
            },
            context: {
                h2TitleOne: "到會小食份量剛剛好，不太飽肚",
                pContentOneFirst: "有些時候如果您想為您的party選擇一些不太飽肚的到會食物，您可能會想要小食類別比較多的餐單。可是，傳統公司一般會將主食和小食等等放在一起，令到客人們需要強制性訂購整個套餐，造成不必要的浪費和與活動性質不對稱。",
                pContentOneSecond: "我們有別一般傳統公司，我們特別設計皇牌餐單，有到會小食及拼盤自選區，您可以在近二十款的小食中選您想要的食物，選擇極多元化。另外我們還有甜品、沙律、冷盤及烘焙包點等等的小食，您可以為您的活動場合選上合適的食物。我們的小食種類繁多，而且是具有多國特色的食物，包括泰式、中式、西式和日式等等。選擇我們到會小食的客人一般場合是茶會、商務會議、下午茶餐及船河等等，如果您正在為您的公司或朋友舉辦派對，需要準備美食及小食，就不容錯過我們的到會小食，歡迎向我們查詢！",
                pContentOneThird: "到會小食推介：粟米碎蛋沙律三文治、香濃芝士豆腐、蒜香蜜糖BBQ雞翼、香脆炸蟹鉗拼吉列帶子、炸粟米墨魚餅拼香燒雞肉丸、新鮮手切串燒波蘿配朱古力醬、日式和果子拼盤（紅豆，抹茶，黑糖）、一口台灣腸等等",
            },
            aboutSnacksTitle: "關於訂購到會小食 - 常見問題:",
            aboutSnacks: {
                faq1: "1. 為何選擇我們的到會小食？",
                content1: "傳統到會食物以主食為多，如飯類、麵類，較少有專屬的到會小食餐單。而事實上，小食往往是眾多食品中最受歡迎的類型，我們就打破傳統框架，專門提供小食系列，有近二十款菜式，讓客人能夠享有更多選擇，來一場滋味盛宴。",
                faq2: "2. 我們有什麼必嚐的到會小食？",
                content2: "我們的每一款到會小食都是由廚師精心炮製，當中人氣之選不少得蒜香蜜糖BBQ雞翼、店揚椒鹽魷魚鬚、日式雞軟骨餃子、XO醬一口牛舌粒、日式明太子餃子雞翼等等。我們的廚師更會定期推出全新菜式，保持新鮮感，讓客人每次都能夠吃到不一樣的食物。",
                faq3: "3. 如何訂購我們的到會小食？",
                content3: "我們提供多種訂購方法，您可選擇直接WhatsApp聯絡我們下單，或是透過我們的網站於線上訂購，只要揀選您想要的套餐、食物、數量，再輸入訂購人的送貨資料，就完成訂購手續，到會家專員將會聯絡您作訂單確認及跟進事宜。",
            },
        },
        chinese: {
            banner: {
                h: "中式到會",
                p: "到會家為您提供獨一無二的中式美食",
                btn: "立即選購"
            },
            content: {
                divf: {
                    p1: "新年到會限定餐單 全港九新界免運費",
                    p2: "熱辣辣惹味煲仔餐單 適合小型親友聚會",
                },
                div1: {
                    h1: "專於傳統，突顯中式到會特色",
                    p1: "每逢新年佳節，很多人都會想在自己家裡煮一些美食，但如果親朋好友太多的話，就會有預訂外賣的念頭，所以很多客人會向我們預訂中菜到會送到府上作為「加餸」。方便您家人在家中可以享受中菜到會，或與朋友同事的節日派對吃中菜迎接節日的來臨。",
                    p2: "我們每逢佳節，都會精心製作出傳統中式美食，而每種美食都有特別的寓意，例如魚同音字「餘」寓意年年有餘、雞諧音為「吉」寓意鴻運當頭、豬手諧音為「手」寓意橫財就手；牛脷喻意「大吉大利」、大蝦喻意「哈哈大笑」，既新穎又保留傳統的韻味。"
                },
                div2: {
                    h1: "度身設計中式到會菜單，配合您的需要",
                    p1: '我們為中式到會設計特色餐單，這些餐單是經過以往的中菜到會的經驗而精心設計的，絕對適合在團年飯和開年飯與您們家中的年長一輩吃。另外，我們更可以根據您的心中的要求，為您度身訂製餐單。如果您有額外的食物要求希望加進中式到會餐單之中，我們都可以為您特意烹飪，只要您想得出的美食，我們都會為您製造得更好更美味。'
                },
                div3: {
                    h2: "立即訂購到會家為您提供的中式到會",
                    btn: "WhatsApp 預訂"
                }
            },
            context: {
                h2TitleOne: "超過三十年中菜經驗的廚師，為您設計中式到會菜式",
                pContentOneFirst: "不知大家是什麼時候會訂中式到會呢？我們相信您叫到會的時候，會有一些長輩等等在場的場合。中式到會是十分適合您們家中的年長一輩吃的，您可能會想訂一些素食、齋、廣東菜等等的食物。但是最常見是在酒樓才可以吃到，叫回家吃的場合相對較少。但除著人們的生活習慣改變，您們的節日可能想留在家裡吃美味的中式食物，而不想和別人在街外等位。中式到會的確是合適送到您們家裡，而我們亦可以製作出美味的中式食品，為您的家庭聚會增添更多的美食。",
                pContentOneSecond: "每逢新年、中秋及聖誕佳節，很多客人都會想在自己家裡煮一些食物，如果親朋好友太多的話，想必煮的那位媽媽都會很辛苦，所以客人為向我們訂中式到會送到府上作為「加餸」。新年最常見的是加一個盆菜和大家一起吃！我們的中式到會除了可以滿足您家裡的每一餐外，我們還可以為您的公司煮出美味的應節食物。我們曾服務過一次超過50枱的中式圍餐及盆菜，而且我們有即場廚師為他們製造不同的美食！",
            },
        },
        western: {
            banner: {
                h: "西式到會",
                p: "服務超過100+不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "西式到會，有20年以上經驗西廚主理",
                span1:
                    "我們的廚師有不少是具有超過20年以上的西餐經驗，如何將西餐菜式的思維融入一份Menu上，是我們一直以來需要不斷突破的問題。在外國，常見西式到會形式包含烘焙包點類和一些小食，但是如果將整套方法套用於香港，則未必能滿足所有客人。香港人對西式到會的期望與外國略有不同，港人會希望除了有小食，亦會包含主食，如意粉、焗飯、炒飯等以飯粉面為主的食物。因此，在融入西方飲食文化的同時，亦需要加入香港元素。例如我們在設計西式美食時，我們會加入卡邦尼意粉，但卡邦尼意粉在運輸過程中會容易變壞，我們便要由傳統製法中加以改良，讓食物運送至客人手上後仍能保持美味。",
                span2:
                    "我們的餐單除了一盤盤的食物以外，我們還有精美西式小食、杯裝小食及高級商務小食等等。只要您向我們告訴您的公司活動需要怎麼樣的西式到會，我們都能依照您的要求製作美食。",
                span3:
                    "皇牌西式小食推介：一口迷你煙三文魚漢堡 、凱撒雞肉沙律手指三文治、香草生菜炒鮮野菌",
                span4:
                    "皇牌杯裝小食推介：煙三文魚他他杯 、北海道牛乳360奶凍"
            },
            aboutWesternTitle: "關於訂購西式到會 - 常見問題:",
            aboutWestern: {
                faq1: "1. 我們的西式到會有什麼招牌推薦食品？",
                content1: "我們特別推薦美式BBQ醬烤原條豬肋骨、原隻香烤燒雞，德國香腸拼盤、炭烤串燒，這是都是西式到會必不可少的重要菜式。除此之外，我們提供不同味道的雞中翼，包括蜜汁、香蒜蜂蜜味、日式明太子味等，全都是人氣之選，保證讓您一試難忘。",
                faq2: "2. 我們的西式到會有什麼食品類型可選？",
                content2: "西式到會多元，我們公司提供各類型西式美食，前菜就有各式冷盤、沙律、小食，主菜方面有意粉、焗飯、燒雞、扒類等等，當然不少得甜品，如泡芙、馬卡龍。我們的西式到會食物種類包羅萬有，定必照顧得到不同客人的口味需要。",
                faq3: "3. 我們的西式到會有何優勢之處？",
                content3: "在西式到會餐單上的每一款菜式，均由我們精心製作。我們嚴選食材、注重食物質素。當然，食物的賣相及味道對我們及客人來說固然重要，但我們於設計菜式上更會考量到運送食品中的注意事項，確保食物送到客人手中後依然美味。",
            },
        },
        thai: {
            banner: {
                h: "泰式到會",
                p: "到會家服務超過100+ 不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "泰式到會食物，色、香、味俱全",
                span1:
                    "泰式到會是市面上比較少見的類型，泰式料理一般比較難掌握，而且香料種類繁多，要製作出色的泰式食物需要色、香、味同時存在食物中。一般非泰式餐廳只能自己生硬地把食物煮出來，送到客人的派對上更是不堪入口，所以客人更要選擇傳統的泰式佳餚。",
                span2:
                    "我們總公司另外開設了泰國餐廳，這間泰國餐廳亦是觀塘區名氣較高的特色餐廳。而我們的泰式餐單亦是由泰國餐廳廚師共同開發，所有的泰式到會是完全加入了當地風味，因此您可以在我們的餐單中找到無骨泰式海南雞、泰式炒金邊粉、泰式豬頸肉、傳統菠蘿炒飯及椰汁千層糕等等。而我們有些菜品也是大廚們每天新鮮製造，手打蝦餅更是我們皇牌必點的食小食，口感彈牙。泰式豬頸肉更是肉汁鮮美。",
                // span3:
                //   "到會家總公司另外開設了泰國餐廳，這間泰國餐廳亦是觀塘區名氣較高的特色餐廳。而我們到會家的泰式餐單亦是由泰國餐廳廚師共同開發，所有的泰式到會是完全加入了泰國風味，因此你可以在我們的餐單中找到無骨泰式海南雞、泰式炒金邊粉、泰式豬頸肉、傳統菠蘿炒飯及椰汁千層糕等等。而我們有些菜品也是大廚們每天新鮮製造，手打蝦餅更是我們皇牌必點的食小食，口感彈牙。泰式豬頸肉更是肉汁鮮美。",
                h2: "泰式到會推介",
                span4: "前菜：泰皇香辣炒肉碎生菜包、泰式酸辣無骨鳳爪",
                span5: "小食：泰式豬頸肉、手打蝦餅",
                span6: "主食：香葉辣椒豬肉碎炒飯、傳統菠蘿炒飯、原隻無骨泰式海南雞",
                span7: "甜品：一口芒果糯米飯、椰汁千層糕"
            },
            aboutThaiTitle: "關於訂購泰式到會 - 常見問題:",
            aboutThai: {
                faq1: "1. 我們的泰式到會有什麼招牌菜？",
                content1: "說到泰式招牌菜，必定會有蝦餅、生菜包、炒金邊粉，我們的泰式到會當然不會錯過這幾道泰式必備菜式。除此之外，我們的廚師特別炮製泰式酸辣無骨鳳爪作為開胃前菜，亦有滋味小食原隻酥炸豬手、無骨泰式海南雞、香口飽肚的香葉辣椒豬肉碎炒飯等等一系列泰式美食。",
                faq2: "2. 我們的泰式到會有什麼食品類型可選？",
                content2: "我們的泰式到會包羅萬有，從泰式沙律，到傳統泰式小食如泰式蝦片、泰式豬頸肉等，主食有炒飯、炒金邊粉等等。除沙律、小食及主食外，當然不少得同時深受大人小孩喜受的泰式甜品。",
                faq3: "3. 為何選擇我們的泰式到會？",
                content3: "傳統到會食物菜式選擇有限，不外乎中式或西式，而我們有別一般公司，會為食品增添新意，因此特別提供泰式到會，讓熱愛泰國菜的朋友可於聚會上品嘗得到與別不同的食物。",
                faq4: "4. 我需要提前預訂到會家的泰式到會嗎？",
                content4: "需要。如欲訂購我們的泰式到會，請提前兩天下單。您可透過網上訂購表格或WhatsApp專線與我們的專員聯絡。",
            },
        },
        vegetarian: {
            banner: {
                h: "素食到會",
                p: "已經服務超過100+不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "素食到會，近年大熱",
                span1:
                    "最近10年來，愈來愈多人開始追求素食潮流，無論是年輕人、工作人士還是退休人士，他們很多都會支持素食，原因是為了動物的生態環境及對牠們的熱愛、個人健康著想及為地球環保出一分力。素食者們亦有兩類，分別是素食者（vegetarian）及全素食者（vegan）。而為了應對這一股熱潮，不少公司都會加入素食到會這一類別的食物，或是走肉食物，滿足客人的需求。而我們亦主動研發出新款及精緻的素食到會，為一班朋友中不吃肉的一群帶來美食。",
                span2:
                    "我們除了皇牌餐單中的無肉之選之外，我們還可以烹調出中式及西式素食。齋類的食品是中式素食到會的代表，我們中菜廚師除了有一身中菜好功夫之外，煮齋亦是我們的拿手好菜。西式素食方面，我們公司亦在中環開設了一間全素食的西式餐廳，融合了西式特式文化的素食，吸引很多中環商業區的上班一族。因此，我們的素食到會絕望是適合外國客人及喜歡西式素食的客人訂購。"
            },
            aboutVegetarianTitle: "關於訂購素食到會 - 常見問題:",
            aboutVegetarian: {
                faq1: "1. 素食到會淡而無味、菜式單調沉悶？",
                content1: "很多人對素食到會都有誤解，認為素食味道必定清淡，菜式亦只有蔬菜水果，款式不夠肉類多元。這個想法大錯特錯，菜類、豆類、瓜類有上千百種，只要用心烹調，自然能製作出美味食物。我們的廚師擅長設計素食菜式，亦有多年烹煮素菜經驗，是首選的素食到會供應商。",
                faq2: "2. 素食到會不夠營養？",
                content2: "不少人對素食到會有另外一些誤解，如不夠營養、肌餓感不斷。其實，素食能提供身體所需營養，如蛋白質與鐵質就能分別於豆類及綠葉蔬菜中汲取。",
                faq3: "3. 素食到會容易產生飢餓感、很快再肚餓？",
                content3: "的確，肉類脂肪較多，胃部需要較多時間消化，因此飽肚感會較持久。而蔬果一般消化時間較短，故容易有肚餓感。不少素食者會進食高纖維食物，如豆類，以延長飽肚感。我們亦有提供高纖維素食菜式，讓您吃畢後飽足感滿滿。",
                faq4: "4. 我能夠同時訂購素食與非素食到會嗎？",
                content4: "當然可以，我們深明不同人士有不同的飲食喜好，有些客人無肉不歡、有些客人則堅持茹素。透過我們，您將能滿足各人的食物要求。只要將所希望訂購的素食款式告訴我們，我們的專員將與您商討菜式，並盡力為您安排。",
            },
        },
        bento: {
            banner: {
                h: "便當",
                p: "服務超過100+不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "公司便當飯盒，方便又美味",
                span1:
                    "便當盒本來是源自日本家庭主婦為自己的丈夫及小朋友準備的午餐，其後這一個文化擴展到世界各地以及香港。香港本地我們常見便當的場合都是午餐，而一般需要訂購便當到會的場合都是為公司商務會議中間的午餐時間。而一個公司飯盒內的食物，包括了開胃小菜、小食、主食及甜點，都可以做得很精緻。",
                span2:
                    "一份精美的便當，確實是承載著製作者對吃的那一位的心意。如果是情侶的話，製作出來的便是愛心飯盒，更會有心形的飯團和心型的愛心雞蛋。如果是媽媽弄的愛心便當盒，想必是更豐富，每一款食物都是母親對子女的愛。而如果是我們烹調出來的公司飯盒，就是我們對每一位吃的人的一份心意。我們希望每一位客人在吃過後，可以有很實在的滿足感，您會感受到這不是與一般茶餐廳一樣的午餐飯盒，這會是一個承載愛和心意的便當！",
                span3: "我們願意會為您的公司每一位同事和上司設計一份十分完美的午餐便當盒，這將會是從前菜到甜點的一份體驗。如果您想為您的公司訂製午餐飯盒，歡迎聯絡我們！",
            },
            aboutBentoTitle: "關於訂購便當到會 - 常見問題:",
            aboutBento: {
                faq1: "1. 我們的便當訂購服務適合哪些場合？",
                content1: "我們的便當訂購服務適合各種場合，常見場合包括公司會議、公司內部聯誼、學校聯歡聚會、教會聚會、生日派對等等。一份美味精緻的便當能拉近人與人之間的距離，藉著美食，同事、朋友一同吃飯聊天，增進感情。",
                faq2: "2. 我們的便當到會有什麼食物選擇？",
                content2: "我們的便當盒主要提供粉麵及飯類，從西式、日本風味，到泰式、馬來西亞，任君選擇。除了粉麵及飯類便當外，您亦可以選三文治便當或小食便當盒。另外，我們提供多格餐盒便當，同一個便當內有多於一款菜式，即除主食外，會配有沙律、雜菜、小食等食物，讓公司便當更豐富更吸引。\n",
                faq3: "3. 有什麼必吃的便當推薦？",
                content3: "我們的便當推介選擇多元，喜歡日本和風的客人可選日式照燒雞扒飯、日式蒲汁鰻魚辣炒飯等；泰菜之選有泰式菠蘿海鮮炒飯、泰式炭燒豬頸肉飯；想品嚐馬拉風味的客人可以嘗試馬來西亞咖喱牛腩飯；西餐類我們特別推薦經典的卡邦尼煙肉燴意粉、義大利肉醬意粉、珍珠帶子墨魚汁意粉等。在眾多款式之中，您定能找到所喜愛的便當盒。",
            },
        },
        central: {
            banner: {
                h: "中環到會",
                p: "到會家服務超過100+ 不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "中環到會",
                span1:
                    "中環是香港的商業中心地區及交通樞紐，亦是多國公司的聚集點，我們在中環能夠看見各國的餐廳包括法國、美國、西班牙、葡萄牙等多國菜式，其中中環到會更加是琳瑯滿目，不管是不同款式的Fingerfood、主菜或甜品簡直是值得打卡的食貨聖地！適合不同國籍人士的口味更是中外文化交匯的象征，在中環叫到會就好像一次過去了不同國家旅遊一樣，只不過這趟旅程視乎個人而定，你可以先去美國再去日本然後到歐洲或者先去歐洲再去日本！",
                span2:
                    "中環到會更是適合不同場合，我們到會家過往在中環亦參與多次大型活動，包括Clockenflap音樂文化節、AIA嘉年華、中環太陽戲團、18+Central和老夫子馬拉松。到會家服務涵蓋的範疇非常之廣，行內認受性非常高。如果你想透過到會美食感受不同國家的味道同特色就致電到會家啦！"
            }
        },
        eastern: {
            banner: {
                h: "北角到會",
                p: "到會家服務超過100+ 不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "北角到會",
                span1:
                    "北角是一個非常有歷史韻味的地方，當地聚集了非常有歷史的學校及商會。到會家（Cateraway）聘請了兩位20年經驗的中西式大廚主理到會餐飲，致力於鑽研北角到會新菜式服務各個商會及學校。商會有非常多活動都有享用我們的服務如雞尾酒會、大型商業會議、船P、宴會、例會等都是我們服務的範疇內，另外學校的節日聯歡會、校運會、開放日等服務我們都擁有不少的服務經驗。",
                span2:
                    "我們到會家有一個宗旨：今天比昨天好一點。兩位大廚相信今時今日的手藝都是用前半身一點一滴積累起來，沒有捷徑也沒有其他故弄玄虛，從學習、實踐、練習及創新一天一天的走到現在。我們相信顧客的舌頭從來都是一視同仁，要令顧客說出一句好食遺失件多麼困難的事情啊！我們要顧客能夠食到不簡簡單單是一種美食的味道那麼簡單，我要顧客食出廚師對北角到會煮食的一種執著！"
            }
        },
        wan: {
            banner: {
                h: "銅鑼灣到會",
                p: "到會家服務超過100+ 不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "銅鑼灣到會",
                span1:
                    "銅鑼灣作為多元化的商業地帶擁有各種商廈、食肆及娛樂地方，不少商業活動都在這片小小的地方進行。我們到會家（Cateraway）針對銅鑼灣到會要求聘請20年經驗的西式大廚製作出不同國家的菜式呈現給銅鑼灣！從公司講座、分享會、宴會、典禮、遊艇會等活動中提供到會餐飲服務。",
                span2:
                    "我們從前菜、主食、小食及甜品的編排、食材的挑選、加工的程序、包裝等一系列流程都有大廚親自監管，確保每一道菜都能以最完美的姿態呈現顧客的眼前。我們亦會經常學習不同國家菜式的烹調方法，您會看到我們包括了意式、日式、中式、西式及泰式的食物種類在餐單，目的就是為了將到會菜單上的款式做得更多元化和更有特色！",
                span3:
                    "我們相信煮食只是不應該簡簡單單表達味道而已，而是表達廚師對國家文化的理解及尊重，除了做出令人垂涎欲滴的菜式之外我們更加想嘗到我們才使得顧客感受到被尊重的的感覺！"
            }
        },
        sham: {
            banner: {
                h: "長沙灣到會",
                p: "到會家服務超過100+ 不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "長沙灣到會",
                span1:
                    "長沙灣和荔枝角是一個商業、住宅、工業三方雲集的地方，在這個地方我們可以看見不同裝束人士，雖然大家有各自的身份，但是我們喜歡美食的本質是永遠不變的！到會家（Cateraway）專門為商業、住宅、工業等用地提供物美價廉的到會服務，其餐單包括了不同國家的特色菜式如泰國原隻菠蘿炒飯、曼谷手打蝦餅 、道地意大利卡邦尼長通粉等更是長沙灣到會的熱門首選，為迎合長沙灣當地口味，我們大廚親身到泰國嚴選香料及食材，並有幸與當地名廚交流傳統泰國咖喱做法，每一道菜式都集合了廚師對烹調的執著，那一份對食的真摯是我們到會家在眾多飲業食行家中生存下來的依據。",
                span2:
                    "對於長沙灣到會和荔枝角到會的定價，我們大廚堅持以合理和性價比高的價錢令普羅大眾得到受惠，他曾揚言：小時候我因為窮沒有享受美食的權利，現在我擁有賦予他人這個權利的話我必須做！"
            }
        },
        yan: {
            banner: {
                h: "尖沙咀、旺角到會",
                p: "到會家服務超過100+ 不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "尖沙咀、旺角到會",
                span1:
                    "尖沙咀、旺角是香港的中心地帶，記得小時候在那裡可以找到不同特色的美食。但是隨著社會的變遷那種各式各樣的美食開始單一化了，能扛得住昂貴的租金、人工的商戶大多數都是較大的飲食集團，他們的菜式不能說好食亦不能說是難食，只能說枯燥太古乏味，大部分都是工場現成在加熱半制成品，要想嘗試新品大都是昙花一现然後都渺無音訊。",
                span2:
                    "現在叫到會就可以試到不同地方的菜式了！到會家（Cateraway）搜羅了不同國家、地區的菜式從中挑選出適合旺角及尖沙咀地區的口味，專門針對尖沙咀到會及旺角到會的市場製作出獨特的菜式，$82就可體驗從頭盤、主菜、小食及甜品下至到包裝、賣相、運輸一條龍服務。我們更會定期將新的元素融入菜單的設計上，務求令到所有的客人在一段時間後可以品嚐新穎的菜式。",
                span3:
                    "追求美食是對生活的一種態度，我們的熱衷就是將這種態度帶給有需要的你！"
            }
        },
        kwai: {
            banner: {
                h: "葵涌到會",
                p: "到會家服務超過100+ 不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "葵涌到會",
                span1:
                    "葵涌是一個多元化的地區，不少年青人都會特意前往該區消費。當地以葵涌廣場為人流最高和消費頻次最高的地方，裡面聚合了各式各樣的食物，吸引不同地區的客人。而葵涌區亦是我們到會家經常送貨的地區之一，這個地區與觀塘區有相似地方，都是一個工廈林立的地區。我們與很多葵涌的Partyroom有到會合作，不少Partyroom亦是我們的商戶。如果您是葵涌區Partyroom的常客，想必您應該都會吃過我們的到會。無論您是去家庭式的派對場所還是去工作坊，到會家都是與葵涌到會息息相關。",
                span2:
                    "葵涌區的居民亦會在吃過我們的到會後，把吃過的美食帶回家分享給他們的家人。一般家庭如果吃厭了常吃的pizza和炸雞等，可以選擇我們到會家的皇牌套餐，裡面包含了中式、西式、日式和泰式的食物，而且款式超過50款食物，可選擇的到會菜式繁多，十分適合家庭預訂。如果想訂購葵涌到會美食，除了電話預訂以外，亦都可以在我們到會家的網站預訂美食，提提您記得提前三天預訂！"
            }
        },
        sai: {
            banner: {
                h: "尖沙咀、旺角到會",
                p: "到會家服務超過100+ 不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "尖沙咀、旺角到會",
                span1:
                    "尖沙咀、旺角是香港的中心地帶，記得小時候在那裡可以找到不同特色的美食。但是隨著社會的變遷那種各式各樣的美食開始單一化了，能扛得住昂貴的租金、人工的商戶大多數都是較大的飲食集團，他們的菜式不能說好食亦不能說是難食，只能說枯燥太古乏味，大部分都是工場現成在加熱半制成品，要想嘗試新品大都是昙花一现然後都渺無音訊。",
                span2:
                    "現在叫到會就可以試到不同地方的菜式了！到會家（Cateraway）搜羅了不同國家、地區的菜式從中挑選出適合旺角及尖沙咀地區的口味，專門針對尖沙咀到會及旺角到會的市場製作出獨特的菜式，$82就可體驗從頭盤、主菜、小食及甜品下至到包裝、賣相、運輸一條龍服務。我們更會定期將新的元素融入菜單的設計上，務求令到所有的客人在一段時間後可以品嚐新穎的菜式。",
                span3:
                    "追求美食是對生活的一種態度，我們的熱衷就是將這種態度帶給有需要的你！"
            }
        },
        tin: {
            banner: {
                h: "沙田到會",
                p: "到會家服務超過100+ 不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "沙田到會",
                span1:
                    "沙田是一個自給自足的社區，裡面住著不同的家庭。我們到會家是家庭客人沙田到會首選的原因是我們可以選擇的美食種類居多，從前菜到甜品有超過40款的美食。而且我們在設計食物的時候，更是改變了很多的美食傳統做法，加入了我們廚師多年的不同國家食物創作經驗，令到本來在送貨過程中容易變壞的食物保持新鮮和好味！餐單有無肉之選，更是一些素食朋友必選的食物。",
                span2:
                    "而在接到沙田到會的訂單中，我們可以看見選擇小朋友餐的訂單是比較多，很多有小朋友的家庭會選擇我們的到會，因為我們有適合小朋友吃的健康到會食物。我們加入了無激素肉類，包括無激素雞翼、雞扒、雞蛋等等，而家甜品方面，想到小朋友對糖份的攝取量，我們設有低糖的啫喱糖，令小朋友吃得更健康。而我們亦有合適老人家吃的蕃薯及南瓜、西蘭花焗薯蓉等等，令到老人家更容易消化。",
                span3:
                    "到會家會為您家庭中的每一位成員考慮周到，立即打電話或網上預訂到會啦！"
            }
        },
        tsuen: {
            banner: {
                h: "荃灣到會",
                p: "到會家服務超過100+ 不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "荃灣到會",
                span1:
                    "荃灣的partyroom們福音到喇！到會家（Cateraway）專門為當地partyroom推出了大學生餐單、小朋友及成人專屬餐單，$82自選餐單從甜品、主食、小食適合不同年齡層享用。為了營造歡樂的玩樂氣氛，我們將時下年輕人的潮流美食都錄入皇牌自選餐單中，而兒童的餐牌我們特意邀請營養學專家打造了一份採用無激素以及營養均衡的食材作為小朋友專用餐牌。從甜品、主食、小食都適合不同年齡層的任食享用，無論一家大小或是三五成群的知己開party都啱曬！",
                span2:
                    "我們追求潮流的頂端，每隔6個月就會推出一份新的潮流餐牌！顧客每一次來都有不同的體驗，就好似每一次來都有不同的旅遊經歷，今天來我嘗到日本菜，下次來我可以試泰國菜，再下次來我可以試法國菜，這就是我們的荃灣到會！",
                span3:
                    "我們的宗旨就是將千奇百款的美食呈現在妳眼前！這趟旅程應該由美國開始還是日本開始呢？"
            }
        },
        tuen: {
            banner: {
                h: "屯門到會",
                p: "到會家服務超過100+ 不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "屯門到會",
                span1:
                    "傳說屯門的朋友仔去邊到都要個半鐘，同朋友去飲飲食食真係要等到意志力爆發先可以啊！現在住得偏遠的朋友仔們唔需要再去到天涯海角去找美食喇！到會家（Cateraway）網羅全港九各區獨特的美食，包括不同有名的各國餐館菜式、潮流特色美食、打卡甜品都應有盡有！我們現在與合共超過300間partyroom、不同類型的公司、慈善團體乃至醫院都是我們的屯門到會的顧客，我們主張每人選一款到會菜式，等你拉埋一班朋友仔試到更多的菜式！",
                span2:
                    "我們到會家設立了專屬車隊專門服務交通比較不方便的朋友仔，專業的司機火速為你送上！我們25年經驗西餐大廚說過：之前我細個時候因為窮，所以冇機會食好食，宜家我有得食好得更好，我想分享俾想食嘅人，因為年輕的時候應該要享受一下，等大個左都可以話翻俾啲子孫聽嘛，哈哈！",
                span3: "食物的真諦不在於味道，而是年輕時候那段回憶！"
            }
        },
        yuen: {
            banner: {
                h: "元朗到會",
                p: "到會家服務超過100+ 不同大小的活動",
                btn: "立即選購"
            },
            content: {
                h: "元朗到會",
                span1:
                    "到會家在新界地區中最最常送到會的是元朗，十八鄉更是我們常送的地方。我們亦曾好奇為什麼這麼多客人會選擇叫到會送到元朗，原來元朗地區的住宅是很多獨立屋，我們問過很多的老客戶，他們跟我們說平常大部份聚會都是燒烤形式，準備功夫亦比較多。而且元朗到會的選擇比較少，很多客人都需要跨區叫食物，但想叫跨區到會時，大部份的公司都不會送這麼偏遠的地方。但我們到會家卻全港配送，所以成為他們常訂購的公司之一！我們到會家的服務是包括港九新界地區，如非禁區或十分偏遠的地區，我們都是會送達的。還記得有一次送元朗到會的時候，送貨地方不能駕車進去，我們的專業司機把兩大箱的食物徒步走了20分鐘，把食物送到客人手中，但客人的無限感激令到我們更有動力！",
                span2:
                    "到會家的每人一款自選到會真的是十分適合您的家庭聚會，如果您的家庭是20人的聚會，您可以在我們的餐單上選擇20款的食物，絕對是到會市場上的創新，令您吃得更開心！"
            }
        },
        setMenus: {
            Private: {
                name1: "私人/公司派對到會"
            },
            business: {
                name1: "商務活動"
            },
            children: {
                name1: "小朋友生日到會"
            },
            boat: {
                name1: "船P美食"
            },
            luncheon: {
                name1: "午餐會"
            },
            refreshments: {
                name1: "茶點"
            }
        },
        dialog: {
            title1: "聯絡方式",
            name: "稱呼",
            names: "請輸入您的稱呼",
            email: "電郵",
            emails: "請輸入電郵",
            phone: "聯絡方式",
            phones: "請輸入聯絡方式",
            company: "公司",
            companys: "請輸入公司名稱",
            title2: "活動詳情",
            eventDate: "日期",
            eventDates: "請選擇日期",
            eventTime: "時間",
            eventTimes: "請選擇時間",
            eventyLocation: "地點",
            eventyLocations: "請輸入地點",
            eumberOfGuests: "貴賓人數",
            budget: "預算",
            budgets: "請輸入預算",
            requiredFoods: "所需食物",
            requiredFoodss: "請輸入所需食物",
            servingstyle: "食物供應形式",
            servingstyles: "自助餐、飯盒...",
            bervage: "飲品",
            bervages: "請輸入所需飲品",
            waiters: "待應生",
            waiterss: "請輸入所選待應生",
            requiredEquipment: "設備要求",
            requiredEquipments: "長枱、熱爐...",
            otherRemarks: "特別要求/安排",
            otherRemarkss: "請輸入特別的要求/安排",
            confirm: "確認",
            cancel: "取消"
        },
        zh: "中文繁體",
        en: "English"
    }
};
